/* eslint-disable no-alert */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Tabs,
  Tab,
  Spinner,
  Modal,
  Badge,
  ListGroup,
} from 'react-bootstrap';
import ReactQuill from 'react-quill';
import '../../assets/svg/styles.css';
import 'react-quill/dist/quill.snow.css';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaTrash,
  FaInfoCircle,
  FaExternalLinkAlt,
} from 'react-icons/fa';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';
import analystIcon from '../../assets/svg/icons/send.svg';
import clientIcon from '../../assets/svg/icons/reply.svg';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import Breadcrumbs from '../../components/Breadcrumbs';
import RichTextEditor from '../../components/RichTextEditor/RichTextEditor';
// Importando o hook de notificações
import { useNotification } from '../../components/Notification/NotificationContext';

// Componente customizado para o react-select CC
function CustomValueContainer(props) {
  const { children, selectProps, ...rest } = props;
  const allOptions = selectProps.options;
  return (
    <components.ValueContainer {...rest} selectProps={selectProps}>
      {children}
      {allOptions.length > 0 && (
        <button
          type="button"
          onClick={() => selectProps.onChange(allOptions)}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0 4px',
            color: '#495057',
          }}
          title="Selecionar todos"
        >
          »»
        </button>
      )}
    </components.ValueContainer>
  );
}
CustomValueContainer.propTypes = {
  children: PropTypes.node.isRequired,
  selectProps: PropTypes.shape({
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        label: PropTypes.string.isRequired,
      })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
};

export default function TicketsEdit() {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const userData = useSelector((state) => state.auth.user);
  const authToken = useSelector((state) => state.auth.token);
  const [status, setStatus] = useState('aberto');
  const [origem, setOrigem] = useState('');
  const [, setEmAtendimento] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [selectedRequesterId, setSelectedRequesterId] = useState('');
  const [, setSelectedUserName] = useState('');
  const [priority, setPriority] = useState('');
  const [stageid, setStages] = useState('');
  const [serviceDesk, setServiceDesk] = useState('');
  const [internalCommunication, setInternalCommunication] = useState('');
  const [clientCommunication, setClientCommunication] = useState('');
  const [users, setUsers] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [title, setTitle] = useState('');
  const [ticketId, setTicketId] = useState(''); // Novo estado para ID do ticket
  const [serviceDeskName, setServiceDeskName] = useState('');
  const [isLoading] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState(null);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState('');
  const [apiLigacao, setApiLigacao] = useState(null);
  // Estados para CC
  const [companyRequesters, setCompanyRequesters] = useState([]);
  const [selectedCCEmails, setSelectedCCEmails] = useState([]);
  const [showCallModal, setShowCallModal] = useState(false);
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState('');
  const [currentCallId, setCurrentCallId] = useState(null);
  // const handleCloseCallModal = () => setShowCallModal(false);
  const [clientCommunicationHistory, setClientCommunicationHistory] = useState(
    []
  );
  const [internalCommunicationHistory, setInternalCommunicationHistory] =
    useState([]);
  const [, setUsersMap] = useState({});
  const [companyName, setCompanyName] = useState('');
  const [requesterName, setRequesterName] = useState('');
  const [requesterEmail, setRequesterEmail] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientCell, setClientCell] = useState('');
  const [clientWhatsApp, setClientWhatsApp] = useState('');
  const [clientInfo, setClientInfo] = useState('');
  const [ticketDescription, setTicketDescription] = useState('');
  // ✅ NOVO ESTADO: para guardar os dados originais do ticket
  const [originalTicket, setOriginalTicket] = useState(null);
  // Estados para popular as opções dos dropdowns
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [filteredPriorities, setFilteredPriorities] = useState([]);
  const [filteredStages, setFilteredStages] = useState([]);
  const [timelineLogs, setTimelineLogs] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const clientQuillRef = useRef();
  const internalQuillRef = useRef();
  const clientFileInputRef = useRef();
  const internalFileInputRef = useRef();
  const [clientFiles, setClientFiles] = useState([]);
  const [internalFiles, setInternalFiles] = useState([]);
  const [isClientDragActive, setIsClientDragActive] = useState(false);
  const [isInternalDragActive, setIsInternalDragActive] = useState(false);
  const notification = useNotification();
  const [recentTickets, setRecentTickets] = useState([]);
  // Estado para controlar o modal de visualização da descrição
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  // Estados para controlar a edição da descrição
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editedDescription, setEditedDescription] = useState('');
  const [isSavingDescription, setIsSavingDescription] = useState(false);
  // Estado para controlar o modal de informações do cliente
  const [showClientInfoModal, setShowClientInfoModal] = useState(false);
  // Estados para controlar a edição das informações do cliente
  const [isEditingClientInfo, setIsEditingClientInfo] = useState(false);
  const [editedClientInfo, setEditedClientInfo] = useState('');
  const [isSavingClientInfo, setIsSavingClientInfo] = useState(false);
  // Estado para o painel lateral de info do cliente
  const [showInfoPanel, setShowInfoPanel] = useState(false);
  const [companyTags, setCompanyTags] = useState([]);

  // ====================================================================================
  // ✅ EFEITO DE CARREGAMENTO DE DADOS CENTRALIZADO E OTIMIZADO
  // ====================================================================================

  // ✅ EFEITO DE CARREGAMENTO DE DADOS CENTRALIZADO E CORRIGIDO
  useEffect(() => {
    const loadAllDataForEdit = async () => {
      try {
        // 1. Busca o ticket com todos os dados já incluídos em UMA ÚNICA CHAMADA
        const ticketResponse = await axios.get(`/tickets/${id}`);
        const ticket = ticketResponse.data;

        if (!ticket) {
          notification('Ticket não encontrado.', 'error');
          navigate('/tickets');
          return;
        }

        // 2. Preenche os estados do formulário com os dados do ticket e seus 'includes'
        setTicketId(ticket.id || '');
        setTitle(ticket.title || '');
        setStatus(ticket.status || 'aberto');
        setOrigem(ticket.origem || '');
        setSelectedDepartment(String(ticket.department || ''));
        setSelectedUserId(ticket.assignedTo || '');
        setPriority(ticket.priority || '');
        setStages(ticket.stageid || '');

        // Preenche informações de entidades relacionadas que já vieram na API
        setServiceDeskName(
          ticket.ServiceDesk ? ticket.ServiceDesk.displayName : 'N/A'
        );
        setCompanyName(
          ticket.Customer
            ? ticket.Customer.nomeEmpresa || ticket.Customer.razaoSocial
            : 'N/A'
        );
        setRequesterName(ticket.requester ? ticket.requester.name : '');
        setRequesterEmail(ticket.requester ? ticket.requester.email : '');
        setClientPhone(ticket.requester ? ticket.requester.telefone : '');
        setClientCell(ticket.requester ? ticket.requester.celular : '');
        setClientWhatsApp(
          ticket.requester ? ticket.requester.whatsapp_notifications : ''
        );
        // Processa a descrição preservando quebras de linha e imagens
        const rawDescription = ticket.descricao_ticket || '';
        const processedDescription = rawDescription
          .replace(/<p><br><\/p>/g, '\n') // Converte parágrafos vazios em quebras de linha
          .replace(/<p>/g, '') // Remove tags <p> de abertura
          .replace(/<\/p>/g, '\n') // Converte </p> em quebras de linha
          .replace(/<br\s*\/?>/g, '\n') // Converte <br> em quebras de linha
          .replace(/&nbsp;/g, ' ') // Substitui &nbsp; por espaços
          .replace(/&lt;/g, '<') // Decodifica entidades HTML
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/\n\s*\n/g, '\n') // Remove quebras de linha duplas desnecessárias
          .trim(); // Remove espaços extras
        setTicketDescription(processedDescription);

        // ✅ SALVA OS DADOS ORIGINAIS DO TICKET NO ESTADO
        setOriginalTicket(ticket);

        // 3. Carrega as OPÇÕES dos dropdowns usando a nova rota otimizada
        if (ticket.serviceDesk) {
          const { data: deskOptions } = await axios.get(
            `/servicedesks/${ticket.serviceDesk}/options`
          );
          setFilteredDepartments(
            deskOptions.options && deskOptions.options.departments
              ? deskOptions.options.departments
              : []
          );
          setFilteredPriorities(
            deskOptions.options && deskOptions.options.priorities
              ? deskOptions.options.priorities
              : []
          );
          setFilteredStages(
            deskOptions.options && deskOptions.options.stages
              ? deskOptions.options.stages
              : []
          );
        }

        // Pré-filtra os usuários para o departamento inicial do ticket
        if (ticket.department) {
          const { data: usersInDept } = await axios.get(
            `/userdpto/${ticket.department}`
          );
          const mappedUsers = usersInDept.map((entry) => ({
            id: entry.UserProfile.User.id, // Usar o user_id real ao invés do userId do DepartamentUser
            name: entry.UserProfile.name,
            lastname: entry.UserProfile.lastname,
          }));
          setFilteredUsers(mappedUsers);
        }

        // 4. Carrega o histórico e outras informações necessárias
        fetchCommunicationHistory(id);
        fetchTimelineLogs(id);
        if (ticket.company) {
          fetchRecentTickets(ticket.company);
          fetchCompanyRequesters(ticket.company); // Busca solicitantes da empresa para CC
          const { data: customerDetails } = await axios.get(
            `/customers/${ticket.company}`
          );
          setClientInfo(customerDetails.notes || '');
          setCompanyTags(customerDetails.tags || []);
        }
        fetchApiLigacao();
        axios.get('/messagetemplate').then((res) => setEmailTemplate(res.data));
        // Carrega os templates de mensagens
        axios.get('/templates').then((res) => setEmailTemplates(res.data));
      } catch (error) {
        console.error('Erro ao carregar dados do ticket:', error);
        notification('Falha ao carregar os dados do ticket.', 'error');
        navigate('/tickets');
      } finally {
        setDataLoaded(true);
      }
    };

    if (id) {
      loadAllDataForEdit();

      // Configurar auto-refresh para comunicações a cada 65 segundos
      const autoRefreshInterval = setInterval(() => {
        fetchCommunicationHistory(id);
        fetchTimelineLogs(id);
      }, 65000); // 65 segundos

      // Cleanup do interval quando o componente for desmontado
      return () => {
        if (autoRefreshInterval) {
          clearInterval(autoRefreshInterval);
        }
      };
    }
  }, [id, navigate, notification]);
  // Função para criar um log
  const createLogEntry = async (action) => {
    try {
      const { data: newLog } = await axios.post('/timeline', {
        ticket_id: id,
        user_id: userData.id,
        action,
      });

      // Insere apenas o log recém-criado no topo da lista (a timeline é
      // ordenada por created_at DESC). Recarregar a timeline inteira a cada
      // registro faz o tráfego crescer de forma quadrática.
      if (newLog && newLog.id) {
        setTimelineLogs((prev) => [newLog, ...prev]);
      } else {
        fetchTimelineLogs(id);
      }
    } catch (error) {
      console.error('Failed to create log entry:', error);
    }
  };

  // Função reutilizável para carregar todos os dados do ticket e popular estados
  const loadAllDataForEdit = async () => {
    try {
      setDataLoaded(false);
      // Busca o ticket com todos os dados em uma única chamada
      const ticketResponse = await axios.get(`/tickets/${id}`);
      const ticket = ticketResponse.data;

      if (!ticket) {
        notification('Ticket não encontrado.', 'error');
        navigate('/tickets');
        return;
      }

      // Preenche estados principais do formulário
      setTicketId(ticket.id || '');
      setTitle(ticket.title || '');
      setStatus(ticket.status || 'aberto');
      setOrigem(ticket.origem || '');
      setSelectedDepartment(String(ticket.department || ''));
      setSelectedUserId(ticket.assignedTo || '');
      setPriority(ticket.priority || '');
      setStages(ticket.stageid || '');

      // Informações relacionadas
      setServiceDeskName(
        ticket.ServiceDesk ? ticket.ServiceDesk.displayName : 'N/A'
      );
      setCompanyName(
        ticket.Customer
          ? ticket.Customer.nomeEmpresa || ticket.Customer.razaoSocial
          : 'N/A'
      );
      setRequesterName(ticket.requester ? ticket.requester.name : '');
      setRequesterEmail(ticket.requester ? ticket.requester.email : '');
      setClientPhone(ticket.requester ? ticket.requester.telefone : '');
      setClientCell(ticket.requester ? ticket.requester.celular : '');
      setClientWhatsApp(
        ticket.requester ? ticket.requester.whatsapp_notifications : ''
      );

      // Processa a descrição preservando quebras de linha e imagens
      const rawDescription = ticket.descricao_ticket || '';
      const processedDescription = rawDescription
        .replace(/<p><br><\/p>/g, '\n')
        .replace(/<p>/g, '')
        .replace(/<\/p>/g, '\n')
        .replace(/<br\s*\/>?/g, '\n')
        .replace(/&nbsp;/g, ' ')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/\n\s*\n/g, '\n')
        .trim();
      setTicketDescription(processedDescription);

      // Salva dados originais para referência
      setOriginalTicket(ticket);

      // Carrega opções de dropdowns
      if (ticket.serviceDesk) {
        const { data: deskOptions } = await axios.get(
          `/servicedesks/${ticket.serviceDesk}/options`
        );
        setFilteredDepartments(
          deskOptions.options && deskOptions.options.departments
            ? deskOptions.options.departments
            : []
        );
        setFilteredPriorities(
          deskOptions.options && deskOptions.options.priorities
            ? deskOptions.options.priorities
            : []
        );
        setFilteredStages(
          deskOptions.options && deskOptions.options.stages
            ? deskOptions.options.stages
            : []
        );
      }

      // Pré-filtra usuários do departamento
      if (ticket.department) {
        const { data: usersInDept } = await axios.get(
          `/userdpto/${ticket.department}`
        );
        const mappedUsers = usersInDept.map((entry) => ({
          id: entry.UserProfile.User.id,
          name: entry.UserProfile.name,
          lastname: entry.UserProfile.lastname,
        }));
        setFilteredUsers(mappedUsers);
      }

      // Carrega histórico e outras informações
      fetchCommunicationHistory(id);
      fetchTimelineLogs(id);
      if (ticket.company) {
        fetchRecentTickets(ticket.company);
        fetchCompanyRequesters(ticket.company);
        const { data: customerDetails } = await axios.get(
          `/customers/${ticket.company}`
        );
        setClientInfo(customerDetails.notes || '');
        setCompanyTags(customerDetails.tags || []);
      }

      fetchApiLigacao();
      axios.get('/messagetemplate').then((res) => setEmailTemplate(res.data));
      axios.get('/templates').then((res) => setEmailTemplates(res.data));
    } catch (error) {
      console.error('Erro ao carregar dados do ticket:', error);
      notification('Falha ao carregar os dados do ticket.', 'error');
      navigate('/tickets');
    } finally {
      setDataLoaded(true);
    }
  };

  const fetchRecentTickets = async (companyId) => {
    try {
      const response = await axios.get(`/tickets/recent/${companyId}`);
      setRecentTickets(response.data || []);
    } catch (error) {
      console.error('Failed to fetch recent tickets:', error);
    }
  };

  const fetchTimelineLogs = async (ticketId) => {
    try {
      const response = await axios.get(`/timeline/${ticketId}`);
      setTimelineLogs(response.data);
    } catch (error) {
      console.error('Failed to fetch timeline logs:', error);
    }
  };

  const fetchCommunicationHistory = async (ticketId) => {
    try {
      const response = await axios.get(`/communicationHistory/${ticketId}`);
      setClientCommunicationHistory(
        response.data.filter((entry) => entry.clientMessage)
      );
      setInternalCommunicationHistory(
        response.data.filter((entry) => entry.internalMessage)
      );
    } catch (error) {
      console.error('Failed to fetch communication history:', error);
    }
  };

  const handleDeleteInternalCommunication = async (entryId) => {
    if (
      !window.confirm(
        'Tem certeza que deseja deletar esta comunicação interna?'
      )
    )
      return;
    try {
      await axios.delete(`/communicationHistory/${entryId}`);
      setInternalCommunicationHistory((prev) =>
        prev.filter((e) => e.id !== entryId)
      );
      notification('Comunicação interna deletada com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao deletar comunicação interna:', error);
      notification('Erro ao deletar comunicação interna.', 'error');
    }
  };

  // Função para buscar solicitantes da empresa
  const fetchCompanyRequesters = async (companyId) => {
    if (!companyId) {
      setCompanyRequesters([]);
      return;
    }

    try {
      const { data: requesters } = await axios.get(
        `/requesters/company/${companyId}`
      );

      // Validar e filtrar dados para garantir que são objetos válidos
      const validRequesters = (requesters || []).filter((requester) => {
        // Verificar se é um objeto válido e não uma Promise
        if (
          !requester ||
          typeof requester !== 'object' ||
          requester instanceof Promise
        ) {
          console.warn('Requester inválido ou Promise detectada:', requester);
          return false;
        }

        // Verificar se tem as propriedades necessárias
        if (!requester.email || !requester.name) {
          console.warn('Requester sem email ou name:', requester);
          return false;
        }

        // Verificar se são strings válidas
        if (
          typeof requester.email !== 'string' ||
          typeof requester.name !== 'string'
        ) {
          console.warn('Email ou name não são strings:', requester);
          return false;
        }

        // Verificar se não contém [object
        if (
          requester.email.includes('[object') ||
          requester.name.includes('[object')
        ) {
          console.warn('Email ou name contém [object:', requester);
          return false;
        }

        // Verificar se não são strings vazias
        if (requester.email.trim() === '' || requester.name.trim() === '') {
          console.warn('Email ou name são strings vazias:', requester);
          return false;
        }

        return true;
      });

      console.log('Solicitantes válidos carregados:', validRequesters.length);
      setCompanyRequesters(validRequesters);
    } catch (error) {
      console.error('Erro ao buscar solicitantes da empresa:', error);
      setCompanyRequesters([]);
    }
  };

  // Função para verificar se um email já existe
  const checkEmailExists = async (email) => {
    if (!email || email.length < 3) return [];

    try {
      const response = await axios.get(
        `/requesters?q=${encodeURIComponent(email)}`
      );
      const requesters = response.data.requesters || [];

      // Garantir que todos os dados são válidos
      return requesters.filter((requester) => {
        return (
          requester &&
          typeof requester === 'object' &&
          requester.email &&
          requester.name &&
          typeof requester.email === 'string' &&
          typeof requester.name === 'string'
        );
      });
    } catch (error) {
      console.error('Erro ao buscar email:', error);
      return [];
    }
  };

  const fetchUsersMap = async () => {
    try {
      const response = await axios.get('/users');
      const usersData =
        response.data && response.data.rows
          ? response.data.rows
          : response.data || [];
      const map = usersData.reduce((acc, user) => {
        acc[user.id] =
          user.UserProfile && user.UserProfile.name
            ? user.UserProfile.name
            : 'Nome não disponível';
        return acc;
      }, {});
      setUsersMap(map);
    } catch (error) {
      console.error('Failed to fetch users map:', error);
    }
  };

  // Função para buscar o perfil do usuário logado e obter o ramal
  const fetchUserRamal = async (userId) => {
    try {
      const response = await axios.get('/profiles');
      const userProfile = response.data.find(
        (profile) => profile.user_id === userId
      ); // Filtra pelo ID do usuário logado
      if (userProfile && userProfile.User && userProfile.User.ramal) {
        return userProfile.User.ramal; // Retornando o ramal do usuário logado
      }
      return null;
    } catch (error) {
      console.error('Erro ao buscar o perfil do usuário:', error);
      return null;
    }
  };

  const getCallCounter = (ticketId) => {
    const storedCounter = localStorage.getItem(`callCounter_${ticketId}`);
    return storedCounter ? parseInt(storedCounter, 10) : 0;
  };

  const incrementCallCounter = (ticketId) => {
    const newCounter = getCallCounter(ticketId) + 1;
    localStorage.setItem(`callCounter_${ticketId}`, newCounter);
    return newCounter;
  };
  // Função para buscar a API de ligações
  const fetchApiLigacao = async () => {
    try {
      const response = await axios.get('/ligacoes');
      if (response.data.length > 0) {
        setApiLigacao(response.data[0]); // Assumindo que há uma única API cadastrada
      }
    } catch (error) {
      console.error('Erro ao buscar a API de ligações:', error);
    }
  };

  // Função para fazer a chamada telefônica usando a API cadastrada
  const makeCall = async (number) => {
    if (!apiLigacao) {
      console.error('Nenhuma API de ligação cadastrada.');
      return;
    }

    const userId = userData.id; // ID do usuário logado
    const userRamal = await fetchUserRamal(userId);
    if (!userRamal) {
      console.error('Ramal do usuário não encontrado.');
      return;
    }

    const ticketId = id; // ID do ticket
    const callCounter = incrementCallCounter(ticketId); // 🔹 Incrementa o contador para esta ligação

    const uniqueCallId = `${ticketId}_${String(callCounter).padStart(6, '0')}`; // Exemplo: 1234_001
    setCurrentCallId(uniqueCallId); // 🔹 Salvando no estado

    console.log(`📞 Iniciando chamada com ID único: ${uniqueCallId}`);

    const { url, method, bodyType, body } = apiLigacao;

    let requestBody;
    if (bodyType === 'raw') {
      const parsedBody = JSON.parse(body);
      parsedBody.origem = userRamal;
      parsedBody.destino = number;
      parsedBody.idcti = uniqueCallId; // 🔹 Usando o ID único correto
      requestBody = JSON.stringify(parsedBody);
    } else if (bodyType === 'x-www-form-urlencoded') {
      const parsedBody = JSON.parse(body);
      const formBody = parsedBody.reduce((acc, field) => {
        acc[field.key] =
          field.value === '{ramal}'
            ? userRamal
            : field.value === '{telefone}'
              ? number
              : field.value === '{idcti}' // 🔹 Aqui estava o erro! Agora está corrigido!
                ? uniqueCallId
                : field.value;
        return acc;
      }, {});
      requestBody = new URLSearchParams(formBody).toString();
    }

    try {
      const response = await axios.post('/proxy-call', {
        url,
        method,
        headers: {
          'Content-Type':
            bodyType === 'raw'
              ? 'application/json'
              : 'application/x-www-form-urlencoded',
        },
        body: requestBody,
      });

      console.log('✅ Ligação realizada:', response.data);
    } catch (error) {
      console.error(
        '❌ Erro ao realizar a ligação via proxy:',
        error.response.data || error.message
      );
    }
  };
  // 🔹 Buscar a gravação após a ligação ser finalizada
  const pollCallRecording = async (
    uniqueCallId,
    interval = 15000,
    maxAttempts = 20
  ) => {
    let attempts = 0;

    const poll = async () => {
      attempts++;
      try {
        const tenantApiConfig = await axios.get('/ligacoes');
        if (!tenantApiConfig.data || tenantApiConfig.data.length === 0) {
          console.error('❌ Nenhuma API de ligação configurada.');
          return;
        }

        const apiDownload = tenantApiConfig.data.find((api) =>
          api.url.includes('/audiodownload')
        );
        if (!apiDownload) {
          console.error('❌ API de download de áudio não encontrada.');
          return;
        }

        const { url, method, bodyType, body, headers } = apiDownload;
        console.log(
          `📡 Tentativa ${attempts}: Buscando gravação em: ${url} para ID: ${uniqueCallId}`
        );

        let requestBody;
        if (bodyType === 'raw') {
          requestBody = JSON.stringify({
            ...JSON.parse(body),
            idunico: uniqueCallId,
            formato: 'wav',
          });
        } else if (bodyType === 'x-www-form-urlencoded') {
          const parsedBody = JSON.parse(body);
          const formBody = parsedBody.reduce((acc, field) => {
            acc[field.key] =
              field.value === '{idunico}'
                ? uniqueCallId
                : field.value === '{formato}'
                  ? 'wav'
                  : field.value;
            return acc;
          }, {});
          requestBody = new URLSearchParams(formBody).toString();
        }

        const response = await axios.post('/proxy-call', {
          url,
          method: method || 'POST',
          headers: {
            'Content-Type':
              bodyType === 'raw'
                ? 'application/json'
                : 'application/x-www-form-urlencoded',
            ...headers,
          },
          body: requestBody,
        });

        if (!response.data || response.data.length === 0) {
          console.warn(
            `⚠️ Tentativa ${attempts}: Nenhuma gravação encontrada para ID: ${uniqueCallId}`
          );
        } else {
          const recording = response.data[0];
          if (recording.status === 'COMPLETADA') {
            console.log('🎙️ Gravação COMPLETADA encontrada:', recording);
            // Processa a gravação
            const { nomeaudio, arquivo_base_64 } = recording;
            const byteCharacters = atob(arquivo_base_64);
            const byteArrays = [];
            for (let i = 0; i < byteCharacters.length; i++) {
              byteArrays.push(byteCharacters.charCodeAt(i));
            }
            const byteArray = new Uint8Array(byteArrays);
            const audioBlob = new Blob([byteArray], { type: 'audio/wav' });

            const formData = new FormData();
            formData.append('nomeaudio', nomeaudio);
            formData.append('ticketId', uniqueCallId);
            formData.append('filedata', audioBlob, `${nomeaudio}.wav`);

            console.log(`🚀 Enviando áudio para o servidor: ${nomeaudio}`);
            const uploadResponse = await axios.post('/recordings', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            });
            console.log('📝 Resposta do upload:', uploadResponse.data);
            await createLogEntry(
              `Gravação de ligação concluída: ${arquivo_base_64}`
            );
            await fetchTimelineLogs(id);
            return; // Finaliza o polling, pois a gravação foi concluída.
          }
          console.log(
            `Gravação encontrada, porém status: ${recording.status}. Continuando polling...`
          );
        }
      } catch (error) {
        console.error(
          `❌ Erro na tentativa ${attempts} para buscar gravação para ID: ${uniqueCallId}`,
          error
        );
      }
      if (attempts < maxAttempts) {
        setTimeout(poll, interval);
      } else {
        console.warn(
          'Número máximo de tentativas alcançado. Encerrando polling.'
        );
      }
    };

    poll();
  };

  useEffect(() => {
    if (currentCallId) {
      // Inicia o polling automaticamente sem depender do fechamento do modal
      pollCallRecording(currentCallId);
    }
  }, [currentCallId]);

  useEffect(() => {
    fetchApiLigacao();
  }, []);

  // COLE ESTE NOVO BLOCO useEffect NO LUGAR DO ANTIGO
  useEffect(() => {
    const loadAllDataForEdit = async () => {
      try {
        setDataLoaded(false);
        // 1. Busca o ticket com todos os dados já incluídos em UMA ÚNICA CHAMADA
        const ticketResponse = await axios.get(`/tickets/${id}`);
        const ticket = ticketResponse.data;

        if (!ticket) {
          notification('Ticket não encontrado.', 'error');
          navigate('/tickets');
          return;
        }

        // 2. Preenche os estados do formulário com os dados do ticket e seus 'includes'
        setOriginalTicket(ticket);
        setTitle(ticket.title || '');
        setStatus(ticket.status || 'aberto');
        setOrigem(ticket.origem || '');
        setSelectedDepartment(String(ticket.department || ''));
        setSelectedUserId(ticket.assignedTo || '');
        setPriority(ticket.priority || '');
        setStages(ticket.stageid || '');

        // Preenche informações de entidades relacionadas que já vieram na API
        setServiceDeskName(
          ticket.ServiceDesk ? ticket.ServiceDesk.displayName : 'N/A'
        );
        setCompanyName(
          ticket.Customer
            ? ticket.Customer.nomeEmpresa || ticket.Customer.razaoSocial
            : 'N/A'
        );
        setRequesterName(ticket.requester ? ticket.requester.name : '');
        setRequesterEmail(ticket.requester ? ticket.requester.email : '');
        setClientPhone(ticket.requester ? ticket.requester.telefone : '');
        setClientCell(ticket.requester ? ticket.requester.celular : '');
        setClientWhatsApp(
          ticket.requester ? ticket.requester.whatsapp_notifications : ''
        );

        // Pré-filtra os usuários para o departamento inicial do ticket
        if (ticket.department) {
          const { data: usersInDept } = await axios.get(
            `/userdpto/${ticket.department}`
          );
          const mappedUsers = usersInDept.map((entry) => ({
            id: entry.UserProfile.User.id, // Usar o user_id real ao invés do userId do DepartamentUser
            name: entry.UserProfile.name,
            lastname: entry.UserProfile.lastname,
          }));
          setUsers(mappedUsers); // Popula a lista de usuários para o dropdown
        }

        // 4. Carrega o histórico e outras informações necessárias
        fetchCommunicationHistory(id);
        fetchTimelineLogs(id);
        if (ticket.company) {
          fetchRecentTickets(ticket.company);
          const { data: customerDetails } = await axios.get(
            `/customers/${ticket.company}`
          );
          setClientInfo(customerDetails.notes || '');
          setCompanyTags(customerDetails.tags || []);
        }
        fetchApiLigacao();
        axios.get('/messagetemplate').then((res) => setEmailTemplate(res.data));
      } catch (error) {
        console.error('Erro ao carregar dados do ticket:', error);
        notification('Falha ao carregar os dados do ticket.', 'error');
        navigate('/tickets');
      } finally {
        setDataLoaded(true);
      }
    };

    if (id) {
      loadAllDataForEdit();
    }
  }, [id, navigate, notification]);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value;
    setSelectedCompany(companyId);
    fetchRequesters(companyId);
    fetchCustomerInfo(companyId).then(setClientInfo);
  };

  // Obter o nome do novo departamento
  const handleDepartmentChange = async (e) => {
    const departmentId = e.target.value;
    const oldDepartmentId = selectedDepartment;

    // Registra o log da mudança de departamento
    if (oldDepartmentId && departmentId !== oldDepartmentId) {
      const oldDepartment = filteredDepartments.find(
        (dept) => dept.id === parseInt(oldDepartmentId, 10)
      );
      const newDepartment = filteredDepartments.find(
        (dept) => dept.id === parseInt(departmentId, 10)
      );

      if (oldDepartment && newDepartment) {
        createLogEntry(
          `${userData.name} alterou o departamento do ticket de "${oldDepartment.name}" para "${newDepartment.name}".`
        );
      }
    }

    setSelectedDepartment(departmentId);
    setSelectedUserId('');

    if (!departmentId) {
      setFilteredUsers([]);
      return;
    }
    try {
      const response = await axios.get(`/userdpto/${departmentId}`);
      if (response.data && response.data.length > 0) {
        const usersInDept = response.data.map((entry) => ({
          id: entry.UserProfile.User.id, // Usar o user_id real ao invés do userId do DepartamentUser
          name: entry.UserProfile.name,
          lastname: entry.UserProfile.lastname,
        }));
        setFilteredUsers(usersInDept);
      } else {
        setFilteredUsers([]);
      }
    } catch (error) {
      console.error('Erro ao buscar usuários pelo departamento:', error);
      setFilteredUsers([]);
    }
  };

  useEffect(() => {
    const fetchUsersByDepartment = async (departmentId) => {
      try {
        // Faz a requisição à API para buscar usuários associados ao departamento
        const response = await axios.get(`/userdpto/${departmentId}`);
        if (response.data && response.data.length > 0) {
          // Extrai os dados dos usuários retornados pela API
          const filteredUsers = response.data.map((entry) => ({
            id: entry.UserProfile.User.id, // Usar o user_id real ao invés do userId do DepartamentUser
            name:
              entry.UserProfile && entry.UserProfile.name
                ? entry.UserProfile.name
                : 'Nome não disponível',
            lastname:
              entry.UserProfile && entry.UserProfile.lastname
                ? entry.UserProfile.lastname
                : '',
          }));

          setFilteredUsers(filteredUsers); // Atualiza a lista de usuários filtrados
        } else {
          setFilteredUsers([]); // Limpa a lista de usuários se a API não retornar nada
        }
      } catch (error) {
        console.error('Erro ao buscar usuários pelo departamento:', error);
        setFilteredUsers([]); // Em caso de erro, limpa a lista de usuários
      }
    };

    if (selectedDepartment) {
      fetchUsersByDepartment(selectedDepartment); // Chama a função ao carregar o departamento selecionado
    }
  }, [selectedDepartment]); // Dispara sempre que o selectedDepartment mudar

  const handleUserChange = (e) => {
    const userId = parseInt(e.target.value, 10);

    // Verifique se o usuário existe na lista filtrada
    const selectedUser = filteredUsers.find((user) => user.id === userId);

    createLogEntry(`${userData.name} alterou o responsável do ticket.`); // Registra a ação no log

    setSelectedUserId(userId);
    setSelectedUserName(
      selectedUser
        ? `${selectedUser.name} ${selectedUser.lastname}`
        : 'Usuário não encontrado'
    );
  };

  // O título é um campo de texto livre: o log NÃO pode ser gerado aqui, senão
  // cada tecla digitada vira uma requisição. O registro é feito uma única vez
  // no handleSubmit, comparando o valor salvo com o valor original do ticket.
  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handlePriorityChange = (e) => {
    const priorityValue = e.target.value;

    const currentpriority = filteredPriorities.find(
      (prio) => prio.id === parseInt(priority, 10)
    );

    // Obter o nome do novo PRIORIDADE
    const newpriority = filteredPriorities.find(
      (prio) => prio.id === parseInt(priorityValue, 10)
    );

    if (priority !== priorityValue) {
      createLogEntry(
        `${userData.name} alterou a prioridade do ticket de ${currentpriority.name} para ${newpriority.name}.`
      );
    }
    setPriority(priorityValue);
  };

  const handleStagesChange = (e) => {
    const stageValue = e.target.value;
    const currentStage = filteredStages.find(
      (stg) => stg.id === parseInt(stageid, 10)
    );

    // Obter o nome do novo stage
    const newStage = filteredStages.find(
      (stg) => stg.id === parseInt(stageValue, 10)
    );

    if (stageid !== stageValue) {
      createLogEntry(
        `${userData.name} alterou a prioridade do ticket de ${currentStage.name} para ${newStage.name}.`
      );
    }

    setStages(stageValue);
  };

  // Handlers de arquivos por aba
  const handleClientFileChange = (e) => {
    const selected = Array.from(e.target.files || []);

    // Registra o log do upload de arquivos
    if (selected.length > 0) {
      const fileNames = selected.map((file) => file.name).join(', ');
      createLogEntry(
        `${userData.name} anexou ${selected.length} arquivo(s): ${fileNames}.`
      );
    }

    setClientFiles((prev) => {
      const merged = [...prev, ...selected];
      if (merged.length > 10) {
        notification('Máximo de 10 anexos permitido.', 'warning');
      }
      return merged.slice(0, 10);
    });
  };
  const handleInternalFileChange = (e) => {
    const selected = Array.from(e.target.files || []);

    // Registra o log do upload de arquivos internos
    if (selected.length > 0) {
      const fileNames = selected.map((file) => file.name).join(', ');
      createLogEntry(
        `${userData.name} anexou ${selected.length} arquivo(s) interno(s): ${fileNames}.`
      );
    }

    setInternalFiles((prev) => {
      const merged = [...prev, ...selected];
      if (merged.length > 10) {
        notification('Máximo de 10 anexos permitido.', 'warning');
      }
      return merged.slice(0, 10);
    });
  };

  const formatBytes = (bytes) => {
    if (!bytes || typeof bytes !== 'number') return '0 KB';
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(1)} KB`;
    const mb = kb / 1024;
    return `${mb.toFixed(1)} MB`;
  };

  const handleClientDragOver = (e) => {
    e.preventDefault();
  };
  const handleClientDrop = (e) => {
    e.preventDefault();
    const dropped = Array.from((e.dataTransfer && e.dataTransfer.files) || []);
    setIsClientDragActive(false);
    if (!dropped.length) return;

    // Registra o log do drag and drop de arquivos
    const fileNames = dropped.map((file) => file.name).join(', ');
    createLogEntry(
      `${userData.name} anexou ${dropped.length} arquivo(s) via drag & drop: ${fileNames}.`
    );

    setClientFiles((prev) => {
      const merged = [...prev, ...dropped];
      if (merged.length > 10) {
        notification('Máximo de 10 anexos permitido.', 'warning');
      }
      return merged.slice(0, 10);
    });
  };

  const handleInternalDragOver = (e) => {
    e.preventDefault();
  };
  const handleInternalDrop = (e) => {
    e.preventDefault();
    const dropped = Array.from((e.dataTransfer && e.dataTransfer.files) || []);
    setIsInternalDragActive(false);
    if (!dropped.length) return;
    setInternalFiles((prev) => {
      const merged = [...prev, ...dropped];
      if (merged.length > 10) {
        notification('Máximo de 10 anexos permitido.', 'warning');
      }
      return merged.slice(0, 10);
    });
  };

  // Remoção/Limpeza por aba
  const removeClientFile = (index) => {
    setClientFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const clearClientFiles = () => {
    setClientFiles([]);
    if (clientFileInputRef.current) clientFileInputRef.current.value = '';
  };
  const removeInternalFile = (index) => {
    setInternalFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const clearInternalFiles = () => {
    setInternalFiles([]);
    if (internalFileInputRef.current) internalFileInputRef.current.value = '';
  };

  const handleTemplateChange = async (e) => {
    const templateId = e.target.value;
    setSelectedTemplateId(templateId);
    if (!templateId) {
      setClientCommunication('');
      return;
    }
    try {
      const { data: template } = await axios.get(`/templates/${templateId}`);
      setClientCommunication(template.content || '');
    } catch (error) {
      console.error('Erro ao buscar conteúdo do template:', error);
    }
  };

  // ✅ handleSubmit CORRIGIDO
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Garante que temos os dados originais antes de tentar salvar
    if (!originalTicket) {
      notification('Os dados do ticket ainda não foram carregados.', 'error');
      return;
    }

    // Cria o payload para a API, começando com todos os dados originais
    // e sobrescrevendo apenas os campos que podem ser alterados no formulário.
    const ticketData = {
      ...originalTicket, // Base com todos os dados
      id: ticketId, // Inclui o ID editável
      title, // Inclui o título editável
      assignedTo: selectedUserId,
      priority,
      stageid,
      department: selectedDepartment,
      status, // Inclui o status atual para não sobrescrever mudanças feitas por outros botões
    };

    const actor =
      (userData.UserProfile && userData.UserProfile.name) ||
      userData.name ||
      userData.email;
    const previousTitle = originalTicket.title || '';

    try {
      await axios.put(`/tickets/${id}`, ticketData);

      // Um único log por edição de título, e não um por caractere digitado.
      if (title !== previousTitle) {
        await createLogEntry(
          `${actor} alterou o título do ticket de "${previousTitle}" para "${title}".`
        );
      }

      await createLogEntry(`${actor} atualizou os dados do ticket.`);

      // Passa a considerar o estado salvo como o novo original, para que um
      // segundo salvamento não registre a mesma alteração de título de novo.
      setOriginalTicket(ticketData);
      notification('Ticket atualizado com sucesso!', 'success');
    } catch (error) {
      console.error('Failed to submit ticket:', error);
      notification('Falha ao atualizar o ticket.', 'error');
    }
  };

  const handleAddComment = async (message, type) => {
    setIsSending(true); // Iniciar o loading
    try {
      const formData = new FormData();
      formData.append('ticketId', id);
      formData.append('userId', userData.id);
      formData.append('clientName', selectedCompany);
      formData.append(
        type === 'client' ? 'clientMessage' : 'internalMessage',
        message
      );
      formData.append('type', type);

      // Adiciona emails CC se for comunicação com cliente
      if (type === 'client' && selectedCCEmails.length > 0) {
        const ccEmailsList = selectedCCEmails
          .filter((cc) => cc && cc.value && cc.value.trim() !== '')
          .map((cc) => cc.value.trim());

        if (ccEmailsList.length > 0) {
          formData.append('ccEmails', JSON.stringify(ccEmailsList));
        }
      }

      const filesToSend = type === 'client' ? clientFiles : internalFiles;
      filesToSend.forEach((file) => {
        formData.append('files', file);
      });

      await axios.post('/communicationHistory', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // Notificação de sucesso
      notification('Comunicação Enviada Com Sucesso!', 'success');

      // Registra o log da comunicação enviada
      const communicationType = type === 'client' ? 'cliente' : 'interna';
      createLogEntry(
        `${userData.name} enviou uma comunicação ${communicationType}.`
      );

      fetchCommunicationHistory(id);
      if (type === 'client') {
        clearClientFiles();
      } else {
        clearInternalFiles();
      }
    } catch (error) {
      console.error('Failed to add comment:', error);

      let errorMessage = 'Erro ao enviar comunicação. Tente novamente.';

      // Verifica se há uma resposta do servidor com erro específico
      if (error.response && error.response.data) {
        const { data } = error.response;

        // Se há um array de erros, pega o primeiro
        if (
          data.errors &&
          Array.isArray(data.errors) &&
          data.errors.length > 0
        ) {
          errorMessage = `Erro: ${data.errors[0]}`;
        }
        // Se há uma mensagem de erro direta
        else if (data.message) {
          errorMessage = `Erro: ${data.message}`;
        }
        // Tratamento específico para erros de status HTTP
        else if (error.response.status === 413) {
          errorMessage =
            'Erro: Arquivo muito grande para ser enviado (máximo 10MB)';
        } else if (error.response.status === 400) {
          errorMessage =
            'Erro: É necessário escrever uma mensagem ou anexar um arquivo';
        } else if (error.response.status === 404) {
          errorMessage = 'Erro: Recurso não encontrado no sistema';
        }
      }
      // Tratamento para erros de MulterError (tipo de arquivo não permitido)
      else if (error.message && error.message.includes('MulterError')) {
        if (error.message.includes('Unexpected field')) {
          errorMessage =
            'Erro: Tipo de arquivo não permitido. Use apenas imagens, documentos, vídeos ou arquivos ZIP/RAR';
        } else if (error.message.includes('File too large')) {
          errorMessage =
            'Erro: Arquivo muito grande para ser enviado (máximo 10MB)';
        } else {
          errorMessage =
            'Erro: Problema com o arquivo enviado. Verifique o tipo e tamanho';
        }
      }
      // Tratamento para erros de rede
      else if (error.code === 'NETWORK_ERROR' || !error.response) {
        errorMessage =
          'Erro: Problema de conexão. Verifique sua internet e tente novamente';
      }

      notification(errorMessage, 'error');
    } finally {
      setIsSending(false); // Finalizar o loading após o envio
    }
  };

  const parseFiles = (files) => {
    // Se já for um array, retorne diretamente
    if (Array.isArray(files)) {
      // Verifica se é um array de strings ou objetos
      if (typeof files[0] === 'string') {
        // Se for um array de strings (exemplo: ["/public/..."])
        return files.map((filePath) => ({
          originalname: filePath.split('/').pop(), // Nome do arquivo
          path: filePath, // Caminho completo do arquivo
        }));
      }
      // Se for um array de objetos (exemplo: [{ originalname: "...", path: "..."}])
      return files;
    }

    // Se for uma string JSON, tente fazer o parsing
    if (typeof files === 'string') {
      try {
        const parsedFiles = JSON.parse(files);
        // Verifica se após o parsing ainda é um array
        if (Array.isArray(parsedFiles)) {
          return parsedFiles;
        }
      } catch (error) {
        console.error('Erro ao fazer parse de files:', error);
        return [];
      }
    }

    // Se não for nem um array nem uma string válida, retorne um array vazio
    return [];
  };

  // Extrai URLs de arquivos da mensagem (imgs/links), útil como fallback quando entries.files está vazio
  const extractFileLinksFromMessage = (message) => {
    if (!message || typeof message !== 'string') return [];
    const urls = [];
    const regex =
      /(https?:\/\/[^"'\s>]+\/(?:api\/(?:public|download)|public)\/[^"'\s<]+)/g;
    // Captura src/href absolutos que apontam para /api/public, /api/download ou /public
    for (const m of message.matchAll(regex)) {
      let url = m[1];
      // Converte /api/public/ para /api/download/
      if (url.includes('/api/public/')) {
        url = url.replace('/api/public/', '/api/download/');
      }
      const name = url.split('/').pop();
      urls.push({ originalname: name, path: url });
    }
    return urls;
  };

  // Função para renderizar imagens inline substituindo as referências no corpo do e-mail
  const replaceInlineImages = (message, files) => {
    const parsedFiles = parseFiles(files);

    // Remove todos os padrões [image: nome] do corpo — os arquivos ficam apenas em "Arquivos em anexo"
    parsedFiles.forEach((file) => {
      const name = file.originalname || 'image.png';
      const regex = new RegExp(
        `\\[image: ${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\]`,
        'g'
      );
      message = message.replace(regex, '');
    });

    return injectTokenInHtml(stripNonImageImgTags(message));
  };

  const handleDownload = async (url, name) => {
    try {
      let cleanUrl = url;

      // Remove o token da query string se existir
      if (cleanUrl.includes('?token=') || cleanUrl.includes('&token=')) {
        const urlObj = new URL(
          cleanUrl.includes('://')
            ? cleanUrl
            : `${axios.defaults.baseURL}${cleanUrl}`
        );
        urlObj.searchParams.delete('token');
        cleanUrl = urlObj.pathname + (urlObj.search ? urlObj.search : '');
      }

      // Se já for uma URL absoluta, remove o token e usa diretamente
      if (/^https?:\/\//i.test(cleanUrl)) {
        const urlObj = new URL(cleanUrl);
        urlObj.searchParams.delete('token');
        cleanUrl = urlObj.toString();
      } else {
        // Para URLs relativas, remove o /api/ do início pois axios.defaults.baseURL já contém /api
        // Exemplo: /api/download/... -> /download/...
        if (cleanUrl.startsWith('/api/api/')) {
          // Se já tiver duplicado, remove ambos
          cleanUrl = cleanUrl.substring(8); // Remove '/api/api/' = 8 caracteres
        } else if (cleanUrl.startsWith('/api/download/')) {
          cleanUrl = cleanUrl.substring(5); // Remove '/api/' = 5 caracteres, fica '/download/...'
        } else if (cleanUrl.startsWith('/api/')) {
          cleanUrl = cleanUrl.substring(5); // Remove '/api/' = 5 caracteres
        }

        // Garante que começa com /
        if (!cleanUrl.startsWith('/')) {
          cleanUrl = `/${cleanUrl}`;
        }
      }

      // Faz a requisição usando axios (que já tem o header Authorization configurado)
      // axios.get com path relativo usa automaticamente o baseURL
      // Exemplo: axios.get('/download/...') com baseURL='https://.../api'
      // resulta em 'https://.../api/download/...'
      const res = await axios.get(cleanUrl, { responseType: 'blob' });
      const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = name || 'download';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (e) {
      console.error('Erro ao baixar arquivo:', e);
      notification(
        'Falha ao baixar arquivo. Verifique suas permissões.',
        'danger'
      );
    }
  };

  const getPublicFilePath = (filePath) => {
    if (!filePath) {
      console.error('Caminho do arquivo indefinido');
      return '';
    }

    // Normaliza o caminho para usar barras normais
    const normalizedPath = String(filePath).replace(/\\/g, '/');
    let finalUrl = '';

    // Se já for uma URL absoluta, converte /api/public para /api/download
    if (/^https?:\/\//i.test(normalizedPath)) {
      // Converte /api/public/ para /api/download/ em URLs absolutas
      if (normalizedPath.includes('/api/public/')) {
        finalUrl = normalizedPath.replace('/api/public/', '/api/download/');
      } else {
        finalUrl = normalizedPath;
      }
    } else if (normalizedPath.startsWith('/api/public/')) {
      // Converte /api/public/ para /api/download/ em caminhos relativos
      finalUrl = normalizedPath.replace('/api/public/', '/api/download/');
    } else if (
      normalizedPath.includes('/backend/public/') ||
      normalizedPath.includes('backend/public/')
    ) {
      // Verifica se é um caminho absoluto (contém 'backend/public' ou similar)
      const publicIndex = normalizedPath.indexOf('public/');
      if (publicIndex !== -1) {
        const relativePath = normalizedPath.substring(publicIndex + 7); // Remove 'public/'
        const pathSegments = relativePath.split('/');
        if (pathSegments.length >= 3) {
          const empresa = pathSegments[0];
          const date = pathSegments[1];
          const fileName = pathSegments[2];
          finalUrl = `/api/download/${empresa}/${date}/${fileName}`;
        }
      }
    } else {
      // Se for um caminho relativo (formato antigo)
      const pathSegments = normalizedPath.split('/');
      if (pathSegments.length >= 3) {
        const empresa = pathSegments[pathSegments.length - 3];
        const date = pathSegments[pathSegments.length - 2];
        const fileName = pathSegments[pathSegments.length - 1];
        finalUrl = `/api/download/${empresa}/${date}/${fileName}`;
      } else {
        console.error('Formato de caminho não reconhecido:', filePath);
        return '';
      }
    }

    // Adiciona o token na query string se disponível
    if (authToken && authToken !== false && finalUrl) {
      const separator = finalUrl.includes('?') ? '&' : '?';
      return `${finalUrl}${separator}token=${encodeURIComponent(authToken)}`;
    }

    return finalUrl;
  };

  // Injeta token em todas as URLs /api/download/ dentro de HTML e corrige /api/api/ duplicado
  const injectTokenInHtml = (html) => {
    if (!html || !authToken) return html;
    // Corrige double /api/api/ em URLs absolutas
    let fixed = html.replace(
      /(https?:\/\/[^"'\s>]*?)\/api\/api\/download\//g,
      '$1/api/download/'
    );
    // Injeta token em src e href apontando para /api/download/ que ainda não têm token
    fixed = fixed.replace(
      /((?:src|href)\s*=\s*)(["'])((?:https?:\/\/[^"'?]*)?\/api\/download\/[^"'?]*)([^"']*\2)/g,
      (_match, attr, quote, url, rest) => {
        if (rest.includes('token=')) return _match; // já tem token, não duplicar
        return `${attr}${quote}${url}?token=${authToken}${rest}`;
      }
    );
    return fixed;
  };

  // Remove <img> tags que referenciam arquivos locais (/api/download/)
  // Todos os anexos do servidor ficam apenas em "Arquivos em anexo", não inline no corpo
  const stripNonImageImgTags = (html) => {
    if (!html) return html;
    return html.replace(
      /<img\s[^>]*?src=["']([^"']*)["'][^>]*>/gi,
      (match, src) => {
        if (
          src.includes('/api/download/') ||
          src.includes('/api/api/download/')
        )
          return '';
        return match;
      }
    );
  };

  // Helper para converter caminhos /public/ para /api/download/
  const addApiPrefix = (url) => {
    if (!url) return '';
    const normalized = url.replace(/\\/g, '/');
    let finalUrl = '';

    // Não altera URLs absolutas ou já com /api/download
    if (
      /^https?:\/\//i.test(normalized) ||
      normalized.startsWith('/api/download/')
    ) {
      finalUrl = normalized;
    } else if (normalized.startsWith('/api/public/')) {
      // Se já começa com /api/, verifica se precisa converter de /api/public para /api/download
      finalUrl = normalized.replace('/api/public/', '/api/download/');
    } else if (normalized.startsWith('/public/')) {
      // Para caminhos relativos que começam com /public/
      finalUrl = normalized.replace('/public/', '/api/download/');
    } else if (normalized.includes('/backend/public/')) {
      // Para caminhos que contêm /backend/public/
      const publicIndex = normalized.indexOf('/backend/public/');
      const relativePath = normalized.substring(publicIndex + 15); // Remove '/backend/public/'
      finalUrl = `/api/download/${relativePath}`;
    } else {
      finalUrl = normalized;
    }

    // Adiciona o token na query string se disponível e a URL for de download
    if (
      authToken &&
      authToken !== false &&
      finalUrl.includes('/api/download/')
    ) {
      const separator = finalUrl.includes('?') ? '&' : '?';
      return `${finalUrl}${separator}token=${encodeURIComponent(authToken)}`;
    }

    return finalUrl;
  };

  const updateTicketStatus = async (newStatus) => {
    const prevStatus = status; // Captura o status anterior antes da atualização
    setStatus(newStatus); // Atualiza o status

    try {
      await axios.put(`/tickets/${id}`, { status: newStatus });
      notification(`Ticket atualizado com sucesso`, 'success');

      if (newStatus === 'fechado') {
        navigate('/tickets'); // Redireciona para a lista de tickets
      }
      // Se o novo status for "em_atendimento" e o status anterior for "pausado", apenas atualiza o status, sem enviar mensagem
      if (newStatus === 'em_atendimento' && prevStatus === 'pausado') {
        createLogEntry(`${userData.name} retomou o atendimento do ticket.`);
        return; // Retorna cedo, não envia a mensagem
      }

      // Garante que o template foi carregado
      if (!emailTemplate) {
        console.error('Email template not loaded');
        return;
      }

      // Seleciona a mensagem correta do template baseado no status
      let message = '';
      if (newStatus === 'em_atendimento') {
        message = emailTemplate.status_em_atendimento;
      } else if (newStatus === 'pausado') {
        message = emailTemplate.status_pausado;
      } else if (newStatus === 'fechado') {
        message = emailTemplate.status_fechado;
      } else {
        message = emailTemplate.status_aberto;
      }

      // Adiciona o logo da assinatura no final da mensagem
      const messageWithSignature = `
        ${message}

      `;

      await handleAddComment(messageWithSignature, 'client'); // Envia a mensagem com o logo ao cliente

      // Cria o log correspondente
      if (newStatus === 'em_atendimento' && prevStatus === 'pausado') {
        createLogEntry(`${userData.name} retomou o atendimento do ticket.`);
      } else if (newStatus === 'em_atendimento') {
        createLogEntry(`${userData.name} iniciou o atendimento do ticket.`);
      } else if (newStatus === 'pausado') {
        createLogEntry(`${userData.name} pausou o atendimento do ticket.`);
      } else if (newStatus === 'fechado') {
        createLogEntry(`${userData.name} encerrou o atendimento do ticket.`);
      }
    } catch (error) {
      notification(`Erro ao atualizar o status do ticket:`, 'success');
      console.error('Erro ao atualizar o status do ticket:', error);
    }
  };

  const handleStart = () => {
    setEmAtendimento(true); // Iniciar atendimento
    updateTicketStatus(
      'em_atendimento',
      `Você iniciou o atendimento do Ticket ${id}`
    );
  };

  const handlePause = () => {
    updateTicketStatus('pausado', `Você pausou o atendimento do Ticket ${id}`);
  };

  const handleEnd = async () => {
    setEmAtendimento(false); // Reseta o estado de atendimento

    // Primeiro, envia a comunicação do cliente se houver conteúdo
    try {
      if (clientCommunication && clientCommunication.trim() !== '') {
        await handleAddComment(clientCommunication, 'client');
        setClientCommunication(''); // Limpa o campo após enviar
        createLogEntry(
          `${(userData.UserProfile && userData.UserProfile.name) || userData.email} enviou comunicação ao cliente antes do encerramento.`
        );
      }
    } catch (error) {
      console.error('Erro ao enviar comunicação antes do encerramento:', error);
      notification(
        'Erro ao enviar comunicação antes do encerramento.',
        'error'
      );
      return; // Para a execução se houver erro
    }

    // Segundo, salva todas as informações do ticket
    try {
      if (originalTicket) {
        const ticketData = {
          ...originalTicket,
          id: ticketId,
          title,
          assignedTo: selectedUserId,
          priority,
          stageid,
          department: selectedDepartment,
        };

        await axios.put(`/tickets/${id}`, ticketData);
        createLogEntry(
          `${(userData.UserProfile && userData.UserProfile.name) || userData.email} atualizou os dados do ticket antes do encerramento.`
        );
      }
    } catch (error) {
      console.error('Erro ao salvar dados antes do encerramento:', error);
      notification('Erro ao salvar dados antes do encerramento.', 'error');
      return; // Para a execução se houver erro
    }

    // Por último, atualiza o status para fechado
    updateTicketStatus(
      'fechado',
      `Você encerrou o atendimento do Ticket ${id}`
    );
  };
  // Função para retomar o atendimento após pausar
  const handleResume = () => {
    setEmAtendimento(false); // Retomar o atendimento localmente
    updateTicketStatus(
      'em_atendimento',
      `Você retomou o atendimento do Ticket ${id}`
    );
  };

  // Função para reabrir o ticket quando estiver fechado
  const handleReopen = async () => {
    try {
      await updateTicketStatus('aberto');
      createLogEntry(
        `${(userData.UserProfile && userData.UserProfile.name) || userData.email} reabriu o atendimento do Ticket ${id}.`
      );
      await loadAllDataForEdit();
    } catch (error) {
      console.error('Erro ao reabrir o ticket:', error);
      notification('Erro ao reabrir o ticket.', 'error');
    }
  };

  // Função para cancelar o ticket
  const handleCancel = async () => {
    if (window.confirm('Tem certeza que deseja cancelar este ticket?')) {
      try {
        await updateTicketStatus('cancelado', `Ticket ${id} foi cancelado`);
        notification('Ticket cancelado com sucesso', 'success');
        // Redireciona para a lista de tickets após cancelar
        navigate('/tickets');
      } catch (error) {
        console.error('Erro ao cancelar ticket:', error);
        notification('Erro ao cancelar ticket', 'error');
      }
    }
  };

  if (!dataLoaded) {
    return <Loading />;
  }

  // Função para realizar a chamada ao clicar no botão de telefone
  const handlePhoneClick = (number) => {
    setCurrentPhoneNumber(number); // Armazena o número atual
    setShowCallModal(true); // Exibe o modal com a mensagem
    makeCall(number); // Realiza a chamada
    createLogEntry(`${userData.name} Ligou para o Nº ${number}.`);
  };

  // Funções para controlar a edição da descrição
  const handleEditDescription = () => {
    // Injeta token para o editor renderizar as imagens corretamente
    setEditedDescription(
      injectTokenInHtml(originalTicket ? originalTicket.descricao_ticket : '')
    );
    setIsEditingDescription(true);
  };

  const handleCancelEditDescription = () => {
    setIsEditingDescription(false);
    setEditedDescription('');
  };

  const handleSaveDescription = async () => {
    if (!editedDescription.trim()) {
      notification('A descrição não pode estar vazia', 'error');
      return;
    }

    setIsSavingDescription(true);
    try {
      // Remove tokens injetados para não persistir URLs com token no banco
      const cleanDescription = editedDescription.replace(
        /([?&])token=[^"'&\s<>]*/g,
        ''
      );
      await axios.put(`/tickets/${id}/description`, {
        descricao_ticket: cleanDescription,
      });

      // Atualizar o ticket original com a descrição limpa (sem token)
      setOriginalTicket((prev) => ({
        ...prev,
        descricao_ticket: cleanDescription,
      }));

      setIsEditingDescription(false);
      notification('Descrição atualizada com sucesso!', 'success');

      // Criar log da alteração
      createLogEntry(`${userData.name} editou a descrição do ticket.`);
    } catch (error) {
      console.error('Erro ao salvar descrição:', error);
      notification('Erro ao salvar a descrição. Tente novamente.', 'error');
    } finally {
      setIsSavingDescription(false);
    }
  };

  // Função para salvar as informações do cliente
  const handleSaveClientInfo = async () => {
    setIsSavingClientInfo(true);
    try {
      await axios.put(`/tickets/${id}/client-info`, {
        informacoes_cliente: editedClientInfo,
      });

      // Atualizar o estado local com as novas informações
      setClientInfo(editedClientInfo);

      // Atualizar o ticket original com as novas informações do cliente
      setOriginalTicket((prev) => ({
        ...prev,
        informacoes_cliente: editedClientInfo,
      }));

      setIsEditingClientInfo(false);
      setEditedClientInfo('');
      notification(
        'Informações do cliente atualizadas com sucesso!',
        'success'
      );

      // Criar log da alteração
      createLogEntry(`${userData.name} editou as informações do cliente.`);
    } catch (error) {
      console.error('Erro ao salvar informações do cliente:', error);
      notification(
        'Erro ao salvar as informações do cliente. Tente novamente.',
        'error'
      );
    } finally {
      setIsSavingClientInfo(false);
    }
  };

  // Função para buscar gravação ao fechar o modal
  const handleCloseCallModal = async () => {
    setShowCallModal(false);

    if (!currentCallId) {
      console.warn(
        '⚠️ Nenhum ID de chamada armazenado. Não foi possível buscar a gravação.'
      );
      return;
    }

    console.log(`🔍 Buscando gravação com ID: ${currentCallId}`);
    // await pollCallRecording(currentCallId);
    // createLogEntry(
    //   `${userData.name} Buscou gravação para o Nº ${currentCallId}.`
    // );
  };

  if (!dataLoaded) {
    return <Loading />;
  }

  const BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://os.opennew.com.br/api';

  return (
    <Container fluid className="px-lg-4 px-xl-15">
      <Breadcrumbs
        title="Tickets"
        pages={[{ name: 'Tickets', link: '/tickets' }]}
      />
      <Modal show={showCallModal} onHide={handleCloseCallModal}>
        <Modal.Header closeButton>
          <Modal.Title>Ligação em andamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Ligando para o número</strong>: {currentPhoneNumber}
          </p>
          <p>
            <strong>⚠️ Importante:</strong> A Gravação estará disponivel ao
            término da ligação.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCallModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Card>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            {/* Primeira linha - ID e Título */}
            <Row className="mb-2">
              <Col md={2}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">
                    ID do Ticket
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={ticketId}
                    onChange={(e) => setTicketId(e.target.value)}
                    placeholder="ID do ticket"
                    disabled
                    size="sm"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">Título</Form.Label>
                  <Form.Control
                    type="text"
                    value={title}
                    onChange={handleTitleChange}
                    placeholder="Título do ticket"
                    size="sm"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">
                    Mesa de serviço
                  </Form.Label>
                  <Form.Control
                    type="text"
                    readOnly
                    disabled
                    value={serviceDeskName}
                    size="sm"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small d-flex align-items-center gap-1">
                    Empresa
                    <Button
                      variant="link"
                      size="sm"
                      className="p-0 text-primary"
                      onClick={() => setShowInfoPanel((v) => !v)}
                      title="Ver últimos tickets e etiquetas do cliente"
                      style={{ lineHeight: 1 }}
                    >
                      <FaInfoCircle size={14} />
                    </Button>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={companyName}
                    disabled
                    size="sm"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Segunda linha - Mesa de serviço e Empresa */}

            {/* Terceira linha - Contatos */}
            <Row className="mb-2">
              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">Telefone</Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="text"
                      value={clientPhone}
                      disabled
                      size="sm"
                    />
                    {clientPhone && (
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="ms-1 px-2"
                        onClick={() => handlePhoneClick(clientPhone)}
                        title="Ligar"
                      >
                        <FaPhoneAlt />
                      </Button>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">Celular</Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="text"
                      value={clientCell}
                      disabled
                      size="sm"
                    />
                    {clientCell && (
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="ms-1 px-2"
                        onClick={() => handlePhoneClick(clientCell)}
                        title="Ligar"
                      >
                        <FaPhoneAlt />
                      </Button>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">WhatsApp</Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="text"
                      value={clientWhatsApp}
                      disabled
                      size="sm"
                    />
                    {clientWhatsApp && (
                      <Button
                        variant="outline-success"
                        size="sm"
                        className="ms-1 px-2"
                        title="WhatsApp"
                      >
                        <FaWhatsapp />
                      </Button>
                    )}
                  </div>
                </Form.Group>
              </Col>
            </Row>

            {/* Quarta linha - Solicitante */}
            <Row className="mb-2">
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">
                    Nome do Solicitante
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={requesterName}
                    disabled
                    size="sm"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">
                    Email do Solicitante
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={requesterEmail}
                    disabled
                    size="sm"
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* Quinta linha - Informações do Cliente e Descrição */}
            <Row className="mb-2">
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">
                    Informações do Cliente (Clique para visualizar completas)
                  </Form.Label>
                  <div
                    style={{
                      height: '100px',
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      fontSize: '13px',
                      lineHeight: '1.3',
                      padding: '6px 10px',
                      borderRadius: '4px',
                      overflow: 'auto',
                      whiteSpace: 'pre-wrap',
                      wordWrap: 'break-word',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                    onClick={() => setShowClientInfoModal(true)}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#e9ecef';
                      e.target.style.borderColor = '#adb5bd';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#f8f9fa';
                      e.target.style.borderColor = '#dee2e6';
                    }}
                    dangerouslySetInnerHTML={{
                      __html: injectTokenInHtml(
                        clientInfo || 'Nenhuma informação disponível'
                      ),
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">
                    Descrição do Ticket (Clique para visualizar completa)
                  </Form.Label>
                  <div
                    style={{
                      height: '100px',
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      fontSize: '13px',
                      lineHeight: '1.3',
                      padding: '6px 10px',
                      borderRadius: '4px',
                      overflow: 'auto',
                      whiteSpace: 'pre-wrap',
                      wordWrap: 'break-word',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                    onClick={() => setShowDescriptionModal(true)}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#e9ecef';
                      e.target.style.borderColor = '#adb5bd';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#f8f9fa';
                      e.target.style.borderColor = '#dee2e6';
                    }}
                    title="Clique para visualizar a descrição completa"
                    dangerouslySetInnerHTML={{
                      __html: injectTokenInHtml(
                        (originalTicket && originalTicket.descricao_ticket
                          ? originalTicket.descricao_ticket
                          : 'Descrição não disponível'
                        )
                          .replace(/<p><br><\/p>/g, '<br>')
                          .replace(/<p>/g, '')
                          .replace(/<\/p>/g, '<br>')
                          .replace(/(<br>\s*){2,}/g, '<br><br>')
                          .replace(/^<br>|<br>$/g, '')
                          .replace(
                            /<img([^>]*?)style="([^"]*?)"([^>]*?)>/g,
                            '<img$1style="$2; max-width: 100%; height: auto;"$3>'
                          )
                          .replace(
                            /<img(?![^>]*style)([^>]*?)>/g,
                            '<img$1 style="max-width: 100%; height: auto;">'
                          )
                      ),
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Sexta linha - Configurações do Ticket */}
            <Row className="mb-2">
              <Col md={3}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">
                    Departamento
                  </Form.Label>
                  <Form.Select
                    value={selectedDepartment}
                    onChange={handleDepartmentChange}
                    size="sm"
                  >
                    <option value="">--Selecione--</option>
                    {filteredDepartments.map((department) => (
                      <option key={department.id} value={department.id}>
                        {department.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">Prioridade</Form.Label>
                  <Form.Select
                    value={priority}
                    onChange={handlePriorityChange}
                    size="sm"
                  >
                    <option value="">--Selecione--</option>
                    {filteredPriorities.map((prio) => (
                      <option key={prio.id} value={prio.id}>
                        {prio.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">Responsável</Form.Label>
                  <Form.Select
                    value={selectedUserId}
                    onChange={handleUserChange}
                    size="sm"
                  >
                    <option value="">--Selecione--</option>
                    {filteredUsers.map((user) => (
                      <option
                        key={user.id}
                        value={user.id}
                      >{`${user.name} ${user.lastname}`}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">Estágio</Form.Label>
                  <Form.Select
                    value={stageid}
                    onChange={handleStagesChange}
                    size="sm"
                  >
                    <option value="">--Selecione--</option>
                    {filteredStages.map((stage) => (
                      <option key={stage.id} value={stage.id}>
                        {stage.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Sétima linha - Status, Origem e Botões de Ação */}
            <Row className="mb-3">
              <Col md={3}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">Status</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    disabled
                    size="sm"
                  >
                    <option value="">--Selecione--</option>
                    <option value="em_atendimento">Em atendimento</option>
                    <option value="aberto">Aberto</option>
                    <option value="fechado">Fechado</option>
                    <option value="pausado">Pausado</option>
                    <option value="cancelado">Cancelado</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-bold small">Origem</Form.Label>
                  <Form.Control
                    type="text"
                    value={origem || '—'}
                    disabled
                    size="sm"
                  />
                </Form.Group>
              </Col>
              <Col md={8} className="d-flex align-items-end">
                {/* Botões organizados horizontalmente */}
                <div className="d-flex gap-3 flex-wrap align-items-start">
                  {/* Seção de Atualização do Formulário */}
                  <div className="d-flex flex-column align-items-start">
                    <small className="text-muted fw-bold mb-1">
                      Formulário:
                    </small>
                    <Button
                      type="submit"
                      variant="primary"
                      size="sm"
                      className="d-flex align-items-center justify-content-center"
                    >
                      <i className="bi bi-arrow-clockwise me-1" />
                      Atualizar Dados
                    </Button>
                  </div>

                  {/* Seção de Ações do Ticket */}
                  <div className="d-flex flex-column align-items-start">
                    <small className="text-muted fw-bold mb-1">
                      Ações do Ticket:
                    </small>
                    <div className="d-flex gap-2 flex-wrap">
                      {status === 'aberto' && (
                        <Button
                          variant="success"
                          onClick={handleStart}
                          size="sm"
                          className="d-flex align-items-center justify-content-center"
                        >
                          <i className="bi bi-play-fill me-1" />
                          Iniciar
                        </Button>
                      )}

                      {status === 'em_atendimento' && (
                        <>
                          <Button
                            variant="warning"
                            onClick={handlePause}
                            size="sm"
                            className="d-flex align-items-center justify-content-center"
                          >
                            <i className="bi bi-pause-fill me-1" />
                            Pausar
                          </Button>
                          <Button
                            variant="danger"
                            onClick={handleEnd}
                            size="sm"
                            className="d-flex align-items-center justify-content-center"
                          >
                            <i className="bi bi-stop-fill me-1" />
                            Encerrar
                          </Button>
                        </>
                      )}

                      {status === 'pausado' && (
                        <Button
                          variant="success"
                          onClick={handleResume}
                          size="sm"
                          className="d-flex align-items-center justify-content-center"
                        >
                          <i className="bi bi-play-fill me-1" />
                          Retomar
                        </Button>
                      )}

                      {status === 'fechado' && (
                        <Button
                          variant="primary"
                          onClick={handleReopen}
                          size="sm"
                          className="d-flex align-items-center justify-content-center"
                          title="Reabrir Ticket"
                        >
                          <i className="bi bi-arrow-counterclockwise me-1" />
                          Reabrir
                        </Button>
                      )}

                      {/* Botão Cancelar - sempre visível exceto para tickets já cancelados ou fechados */}
                      {status !== 'cancelado' && status !== 'fechado' && (
                        <Button
                          variant="danger"
                          onClick={handleCancel}
                          size="sm"
                          title="Cancelar Ticket"
                          className="d-flex align-items-center justify-content-center"
                        >
                          <i className="bi bi-x-circle me-1" />
                          Cancelar Ticket
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
        <Card.Footer>
          <Tabs
            defaultActiveKey="clientCommunication"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="clientCommunication" title="Comunicação com Cliente">
              <Form.Group className="mb-3">
                <Form.Label>Modelo de Mensagem</Form.Label>
                <Form.Select
                  value={selectedTemplateId}
                  onChange={handleTemplateChange}
                >
                  <option value="">--Selecione um modelo--</option>
                  {emailTemplates.map((template) => (
                    <option key={template.id} value={template.id}>
                      {template.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* Campo CC para múltiplos emails */}
              <Form.Group className="mb-3">
                <Form.Label>CC (Cópia para outros solicitantes)</Form.Label>
                <CreatableSelect
                  isMulti
                  components={{ ValueContainer: CustomValueContainer }}
                  value={selectedCCEmails}
                  onChange={(selectedOptions) => {
                    // Garantir que sempre seja um array de objetos válidos
                    const validOptions = (selectedOptions || []).filter(
                      (option) => {
                        return (
                          option &&
                          option.value &&
                          option.label &&
                          typeof option.value === 'string' &&
                          typeof option.label === 'string' &&
                          !String(option.value).includes('[object') &&
                          !String(option.label).includes('[object')
                        );
                      }
                    );
                    console.log('CC emails selecionados:', validOptions);
                    setSelectedCCEmails(validOptions);
                  }}
                  onCreateOption={(inputValue) => {
                    // Validar se é um email válido
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (emailRegex.test(inputValue)) {
                      const newOption = {
                        value: inputValue.toLowerCase().trim(),
                        label: `${inputValue.toLowerCase().trim()} (Email personalizado)`,
                        __isNew__: true,
                      };
                      setSelectedCCEmails((prev) => [...prev, newOption]);
                      notification(
                        `Email personalizado "${inputValue}" adicionado à lista CC`,
                        'success'
                      );
                    } else {
                      notification(
                        'Por favor, digite um email válido (exemplo: usuario@dominio.com)',
                        'error'
                      );
                    }
                  }}
                  isValidNewOption={(inputValue) => {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emailRegex.test(inputValue) && inputValue.length > 0;
                  }}
                  formatCreateLabel={(inputValue) =>
                    `Adicionar email: "${inputValue}"`
                  }
                  options={companyRequesters
                    .filter((requester) => {
                      // Verificação rigorosa para evitar Promises
                      if (
                        !requester ||
                        typeof requester !== 'object' ||
                        requester instanceof Promise
                      ) {
                        console.warn(
                          'Requester inválido no options:',
                          requester
                        );
                        return false;
                      }

                      return (
                        requester.email &&
                        requester.name &&
                        typeof requester.email === 'string' &&
                        typeof requester.name === 'string' &&
                        !requester.email.includes('[object') &&
                        !requester.name.includes('[object')
                      );
                    })
                    .map((requester) => {
                      const email = String(requester.email).trim();
                      const name = String(requester.name).trim();

                      // Verificação adicional antes de criar a opção
                      if (
                        email.includes('[object') ||
                        name.includes('[object')
                      ) {
                        console.warn('Dados inválidos detectados no map:', {
                          email,
                          name,
                        });
                        return null;
                      }

                      return {
                        value: email,
                        label: `${name} (${email})`,
                      };
                    })
                    .filter((option) => option !== null)}
                  filterOption={(option, inputValue) => {
                    if (!inputValue) return true;
                    const searchValue = String(inputValue).toLowerCase();
                    const optionLabel = String(option.label).toLowerCase();
                    const optionValue = String(option.value).toLowerCase();
                    return (
                      optionLabel.includes(searchValue) ||
                      optionValue.includes(searchValue)
                    );
                  }}
                  placeholder="Selecione solicitantes ou digite emails personalizados..."
                  isSearchable
                  noOptionsMessage={({ inputValue }) => {
                    if (inputValue && inputValue.length >= 3) {
                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      if (emailRegex.test(inputValue)) {
                        return `Pressione Enter para adicionar "${inputValue}" como email personalizado`;
                      }
                      return `Nenhum solicitante encontrado para "${inputValue}". Digite um email válido para adicionar.`;
                    }
                    return 'Digite para buscar solicitantes ou adicionar emails personalizados';
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (
                      action === 'input-change' &&
                      inputValue &&
                      inputValue.length >= 3
                    ) {
                      // Verificar se o input parece ser um email
                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      if (emailRegex.test(inputValue)) {
                        // Executar verificação de forma assíncrona sem bloquear
                        checkEmailExists(inputValue)
                          .then((existingEmails) => {
                            if (existingEmails.length > 0) {
                              notification(
                                `E-mail "${inputValue}" já existe no sistema: ${existingEmails[0].name}`,
                                'info'
                              );
                            }
                          })
                          .catch((error) => {
                            console.error(
                              'Erro na verificação de email:',
                              error
                            );
                          });
                      }
                    }
                  }}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: '38px',
                      borderColor: '#ced4da',
                      '&:hover': {
                        borderColor: '#ced4da',
                      },
                    }),
                    multiValue: (provided) => ({
                      ...provided,
                      backgroundColor: '#e9ecef',
                    }),
                    multiValueLabel: (provided) => ({
                      ...provided,
                      color: '#495057',
                    }),
                  }}
                />
                <Form.Text className="text-muted">
                  Digite para pesquisar por nome ou e-mail. Use o botão »» para
                  selecionar todos.
                </Form.Text>
              </Form.Group>

              <ReactQuill
                ref={clientQuillRef}
                theme="snow"
                value={clientCommunication}
                onChange={setClientCommunication}
                style={{ height: '200px' }}
              />
              <Form.Group className="mt-3">
                <Form.Label>
                  <strong />
                </Form.Label>
                <div
                  className="mt-2"
                  onDragOver={handleClientDragOver}
                  onDrop={handleClientDrop}
                  onDragEnter={() => setIsClientDragActive(true)}
                  onDragLeave={() => setIsClientDragActive(false)}
                  style={{
                    border: isClientDragActive
                      ? '2px dashed #0d6efd'
                      : '2px dashed #ccc',
                    borderRadius: '8px',
                    padding: '8px',
                    transition: 'border-color 0.2s',
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() =>
                        clientFileInputRef.current &&
                        clientFileInputRef.current.click()
                      }
                      title="Anexar arquivos"
                    >
                      📎
                    </Button>
                    <span
                      className="badge bg-secondary"
                      title="Arquivos selecionados"
                    >
                      {(clientFiles && clientFiles.length) || 0}
                    </span>
                    <Form.Control
                      type="file"
                      multiple
                      ref={clientFileInputRef}
                      onChange={handleClientFileChange}
                      style={{ display: 'none' }}
                    />
                    <small className="text-muted">Arraste arquivos aqui</small>
                  </div>
                  {clientFiles && clientFiles.length > 0 && (
                    <div className="mt-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <small>
                          {clientFiles.length} arquivo(s) ·{' '}
                          {formatBytes(
                            clientFiles.reduce(
                              (acc, f) =>
                                acc + (typeof f.size === 'number' ? f.size : 0),
                              0
                            )
                          )}
                        </small>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={clearClientFiles}
                        >
                          Limpar
                        </Button>
                      </div>
                      <ul className="list-unstyled mt-2">
                        {clientFiles.map((file, index) => {
                          const isImage =
                            file && file.type && file.type.startsWith('image/');
                          const isAudio =
                            file && file.type && file.type.startsWith('audio/');
                          const ext =
                            file && file.name
                              ? file.name.split('.').pop().toLowerCase()
                              : '';
                          let typeIcon = '📄';
                          if (isImage) typeIcon = '🖼️';
                          else if (isAudio) typeIcon = '🎵';
                          else if (['pdf'].includes(ext)) typeIcon = '📕';
                          else if (['doc', 'docx'].includes(ext))
                            typeIcon = '📝';
                          else if (['xls', 'xlsx', 'csv'].includes(ext))
                            typeIcon = '📊';
                          else if (['ppt', 'pptx'].includes(ext))
                            typeIcon = '📈';
                          else if (['zip', 'rar', '7z'].includes(ext))
                            typeIcon = '🗜️';
                          else if (['txt', 'log'].includes(ext))
                            typeIcon = '📜';
                          const sizeKb =
                            typeof file &&
                            file.size &&
                            typeof file.size === 'number'
                              ? (file.size / 1024).toFixed(1)
                              : null;
                          const previewUrl = isImage
                            ? URL.createObjectURL(file)
                            : null;
                          return (
                            <li
                              key={index}
                              className="d-flex align-items-center mb-2"
                            >
                              {isImage ? (
                                <img
                                  src={previewUrl}
                                  alt={file.name}
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    marginRight: '8px',
                                  }}
                                />
                              ) : (
                                <span style={{ marginRight: '8px' }}>
                                  {typeIcon}
                                </span>
                              )}
                              <div className="flex-grow-1">
                                <div style={{ fontSize: '0.9rem' }}>
                                  {file.name}
                                </div>
                                {sizeKb && (
                                  <small className="text-muted">
                                    {sizeKb} KB
                                  </small>
                                )}
                              </div>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => removeClientFile(index)}
                              >
                                Remover
                              </Button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </Form.Group>
              <Button
                className="mt-3"
                onClick={() => {
                  handleAddComment(clientCommunication, 'client');
                  setClientCommunication('');
                  setSelectedCCEmails([]); // Limpa os emails CC após envio
                }}
                disabled={isSending}
              >
                {isSending ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  'Enviar Comunicação'
                )}
              </Button>
              <h4 className="mt-4">Histórico de Comunicação com Cliente</h4>
              {clientCommunicationHistory.map((entry) => (
                <div
                  key={entry.id}
                  className={`message-container ${entry.whos === 'Cliente' ? 'client-message' : 'analyst-message'}`}
                >
                  <img
                    src={entry.whos === 'Cliente' ? clientIcon : analystIcon}
                    alt="Profile"
                    className="message-icon"
                  />
                  <div>
                    <strong>{entry.whos}</strong>{' '}
                    <span className="message-timestamp">
                      {new Date(
                        entry.created_at || entry.created_at
                      ).toLocaleString()}
                    </span>
                    <div
                      className="message-text email-style"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          replaceInlineImages(entry.clientMessage, entry.files)
                        ),
                      }}
                    />
                    {(() => {
                      const parsed = parseFiles(entry.files);
                      const list = parsed.length
                        ? parsed
                        : extractFileLinksFromMessage(entry.clientMessage);
                      if (!list.length) return null;
                      return (
                        <div>
                          <h6>Arquivos em anexo:</h6>
                          <ul>
                            {list.map((file, index) => {
                              const filePath = file.path || file;
                              const fileName =
                                file.originalname || filePath.split('/').pop();
                              const fileUrl = getPublicFilePath(filePath);

                              // Verifica se é um arquivo de áudio
                              const isAudio =
                                fileName.includes('.mp3') ||
                                fileName.includes('.ogg') ||
                                fileName.includes('.wav') ||
                                fileName.includes('.flac') ||
                                fileName.includes('.m4a');

                              // Verifica se é uma imagem
                              const isImage =
                                fileName.includes('.jpg') ||
                                fileName.includes('.jpeg') ||
                                fileName.includes('.png') ||
                                fileName.includes('.gif') ||
                                fileName.includes('.bmp') ||
                                fileName.includes('.webp');

                              if (isAudio) {
                                return (
                                  <div
                                    key={index}
                                    style={{ marginBottom: '10px' }}
                                  >
                                    <div>
                                      <strong>🎵 Áudio:</strong> {fileName}
                                    </div>
                                    <audio
                                      controls
                                      style={{
                                        width: '100%',
                                        maxWidth: '400px',
                                      }}
                                    >
                                      <source src={fileUrl} type="audio/mpeg" />
                                      Seu navegador não suporta o elemento de
                                      áudio.
                                    </audio>
                                    <div>
                                      <a
                                        href={fileUrl}
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          handleDownload(fileUrl, fileName);
                                        }}
                                        style={{
                                          marginLeft: '10px',
                                          fontSize: '12px',
                                        }}
                                      >
                                        📥 Baixar
                                      </a>
                                    </div>
                                  </div>
                                );
                              }
                              if (isImage) {
                                return (
                                  <div
                                    key={index}
                                    style={{ marginBottom: '10px' }}
                                  >
                                    <img
                                      src={fileUrl}
                                      alt={fileName}
                                      style={{
                                        maxWidth: '100%',
                                        height: 'auto',
                                      }}
                                    />
                                    <div>
                                      <a
                                        href={fileUrl}
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          handleDownload(fileUrl, fileName);
                                        }}
                                        style={{ fontSize: '12px' }}
                                      >
                                        📥 Baixar {fileName}
                                      </a>
                                    </div>
                                  </div>
                                );
                              }
                              // Para outros tipos de arquivo (documentos, etc.)
                              return (
                                <li key={index}>
                                  <a
                                    href={fileUrl}
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      handleDownload(fileUrl, fileName);
                                    }}
                                  >
                                    📄 {fileName}
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              ))}
            </Tab>
            <Tab eventKey="internalCommunication" title="Comunicação Interna">
              <ReactQuill
                ref={internalQuillRef}
                theme="snow"
                value={internalCommunication}
                onChange={setInternalCommunication}
                style={{ height: '200px' }}
              />
              <Form.Group className="mt-3">
                <Form.Label>
                  <strong />
                </Form.Label>
                <div
                  className="mt-2"
                  onDragOver={handleInternalDragOver}
                  onDrop={handleInternalDrop}
                  onDragEnter={() => setIsInternalDragActive(true)}
                  onDragLeave={() => setIsInternalDragActive(false)}
                  style={{
                    border: isInternalDragActive
                      ? '2px dashed #0d6efd'
                      : '2px dashed #ccc',
                    borderRadius: '8px',
                    padding: '8px',
                    transition: 'border-color 0.2s',
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() =>
                        internalFileInputRef.current &&
                        internalFileInputRef.current.click()
                      }
                      title="Anexar arquivos"
                    >
                      📎
                    </Button>
                    <span
                      className="badge bg-secondary"
                      title="Arquivos selecionados"
                    >
                      {(internalFiles && internalFiles.length) || 0}
                    </span>
                    <Form.Control
                      type="file"
                      multiple
                      ref={internalFileInputRef}
                      onChange={handleInternalFileChange}
                      style={{ display: 'none' }}
                    />
                    <small className="text-muted">Arraste arquivos aqui</small>
                  </div>
                  {internalFiles && internalFiles.length > 0 && (
                    <div className="mt-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <small>
                          {internalFiles.length} arquivo(s) ·{' '}
                          {formatBytes(
                            internalFiles.reduce(
                              (acc, f) =>
                                acc + (typeof f.size === 'number' ? f.size : 0),
                              0
                            )
                          )}
                        </small>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={clearInternalFiles}
                        >
                          Limpar
                        </Button>
                      </div>
                      <ul className="list-unstyled mt-2">
                        {internalFiles.map((file, index) => {
                          const isImage =
                            file && file.type && file.type.startsWith('image/');
                          const isAudio =
                            file && file.type && file.type.startsWith('audio/');
                          const ext =
                            file && file.name
                              ? file.name.split('.').pop().toLowerCase()
                              : '';
                          let typeIcon = '📄';
                          if (isImage) typeIcon = '🖼️';
                          else if (isAudio) typeIcon = '🎵';
                          else if (['pdf'].includes(ext)) typeIcon = '📕';
                          else if (['doc', 'docx'].includes(ext))
                            typeIcon = '📝';
                          else if (['xls', 'xlsx', 'csv'].includes(ext))
                            typeIcon = '📊';
                          else if (['ppt', 'pptx'].includes(ext))
                            typeIcon = '📈';
                          else if (['zip', 'rar', '7z'].includes(ext))
                            typeIcon = '🗜️';
                          else if (['txt', 'log'].includes(ext))
                            typeIcon = '📜';
                          const sizeKb =
                            typeof file &&
                            file.size &&
                            typeof file.size === 'number'
                              ? (file.size / 1024).toFixed(1)
                              : null;
                          const previewUrl = isImage
                            ? URL.createObjectURL(file)
                            : null;
                          return (
                            <li
                              key={index}
                              className="d-flex align-items-center mb-2"
                            >
                              {isImage ? (
                                <img
                                  src={previewUrl}
                                  alt={file.name}
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    marginRight: '8px',
                                  }}
                                />
                              ) : (
                                <span style={{ marginRight: '8px' }}>
                                  {typeIcon}
                                </span>
                              )}
                              <div className="flex-grow-1">
                                <div style={{ fontSize: '0.9rem' }}>
                                  {file.name}
                                </div>
                                {sizeKb && (
                                  <small className="text-muted">
                                    {sizeKb} KB
                                  </small>
                                )}
                              </div>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => removeInternalFile(index)}
                              >
                                Remover
                              </Button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </Form.Group>
              <Button
                className="mt-3"
                onClick={() => {
                  handleAddComment(internalCommunication, 'internal');
                  setInternalCommunication('');
                }}
              >
                {isLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  'Enviar Comunicação'
                )}
              </Button>
              <h4 className="mt-4">Histórico de Comunicação Interna</h4>
              {internalCommunicationHistory.map((entry) => (
                <div
                  key={entry.id}
                  className={`message-container ${entry.whos === 'Cliente' ? 'client-message' : 'analyst-message'}`}
                >
                  <img
                    src={entry.whos === 'Cliente' ? clientIcon : analystIcon}
                    alt="Profile"
                    className="message-icon"
                  />
                  <div>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <strong>{entry.whos}</strong>{' '}
                        <span className="message-timestamp">
                          {new Date(
                            entry.created_at || entry.created_at
                          ).toLocaleString()}
                        </span>
                      </div>
                      {entry.userId === userData.id && (
                        <Button
                          variant="link"
                          size="sm"
                          className="text-danger p-0 ms-2"
                          title="Deletar comunicação interna"
                          onClick={() =>
                            handleDeleteInternalCommunication(entry.id)
                          }
                        >
                          <FaTrash />
                        </Button>
                      )}
                    </div>
                    <div
                      className="message-text email-style"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          replaceInlineImages(
                            entry.internalMessage,
                            entry.files
                          )
                        ),
                      }}
                    />
                    {entry.files && entry.files.length > 0 && (
                      <div>
                        <h6>Arquivos em anexo:</h6>
                        <ul>
                          {parseFiles(entry.files).map((file, index) => {
                            const filePath = file.path || file;
                            const fileName =
                              file.originalname || filePath.split('/').pop();
                            const fileUrl = getPublicFilePath(filePath);

                            const isAudio =
                              fileName.includes('.mp3') ||
                              fileName.includes('.ogg') ||
                              fileName.includes('.wav') ||
                              fileName.includes('.flac') ||
                              fileName.includes('.m4a');

                            const isImage =
                              fileName.includes('.jpg') ||
                              fileName.includes('.jpeg') ||
                              fileName.includes('.png') ||
                              fileName.includes('.gif') ||
                              fileName.includes('.bmp') ||
                              fileName.includes('.webp');

                            if (isAudio) {
                              return (
                                <div
                                  key={index}
                                  style={{ marginBottom: '10px' }}
                                >
                                  <div>
                                    <strong>🎵 Áudio:</strong> {fileName}
                                  </div>
                                  <audio
                                    controls
                                    style={{ width: '100%', maxWidth: '400px' }}
                                  >
                                    <source src={fileUrl} type="audio/mpeg" />
                                    Seu navegador não suporta o elemento de
                                    áudio.
                                  </audio>
                                  <div>
                                    <a
                                      href={fileUrl}
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        handleDownload(fileUrl, fileName);
                                      }}
                                      style={{
                                        marginLeft: '10px',
                                        fontSize: '12px',
                                      }}
                                    >
                                      📥 Baixar
                                    </a>
                                  </div>
                                </div>
                              );
                            }

                            if (isImage) {
                              return (
                                <div
                                  key={index}
                                  style={{ marginBottom: '10px' }}
                                >
                                  <img
                                    src={fileUrl}
                                    alt={fileName}
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                  />
                                  <div>
                                    <a
                                      href={fileUrl}
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        handleDownload(fileUrl, fileName);
                                      }}
                                      style={{ fontSize: '12px' }}
                                    >
                                      📥 Baixar {fileName}
                                    </a>
                                  </div>
                                </div>
                              );
                            }

                            return (
                              <li key={index}>
                                <a
                                  href={fileUrl}
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    handleDownload(fileUrl, fileName);
                                  }}
                                >
                                  📄 {fileName}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </Tab>
            <Tab eventKey="timeline" title="Linha do Tempo">
              <h4 className="mt-4">Logs do Ticket</h4>
              {timelineLogs.length === 0 ? (
                <p>Nenhum log disponível.</p>
              ) : (
                timelineLogs.map((log, index) => (
                  <div key={index} className="mb-3">
                    <strong>{log.user_name || 'Sistema'}</strong>{' '}
                    <span>
                      {new Date(
                        log.created_at || log.timestamp
                      ).toLocaleString()}
                    </span>
                    {/* 🔹 Verifica se é um arquivo de áudio */}
                    {log.action.includes('.mp3') ||
                    log.action.includes('.ogg') ||
                    log.action.includes('.wav') ||
                    log.action.includes('.flac') ||
                    log.action.includes('.m4a') ? (
                      <div className="audio-container">
                        <p>
                          <strong>📞 Gravação de ligação:</strong>{' '}
                          <a
                            href={addApiPrefix(log.action)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {log.action.split('/').pop()}
                          </a>
                        </p>

                        {/* 🔹 Player de áudio para ouvir a gravação */}
                        <audio controls>
                          <source
                            src={addApiPrefix(log.action)}
                            type={`audio/${log.action.split('.').pop()}`}
                          />
                          Seu navegador não suporta áudio embutido.
                        </audio>

                        {/* 🔹 Botão para baixar o áudio */}
                        <br />
                        <a
                          href={addApiPrefix(log.action)}
                          download
                          className="btn btn-primary btn-sm mt-2"
                        >
                          📥 Baixar Áudio
                        </a>
                      </div>
                    ) : (
                      <p>{log.action}</p> // Exibir ação normal caso não seja áudio
                    )}
                  </div>
                ))
              )}
            </Tab>

            <Tab eventKey="recentTickets" title="Últimos Tickets">
              {recentTickets.length === 0 ? (
                <p>Nenhum ticket encontrado.</p>
              ) : (
                <ul>
                  {recentTickets.map((ticket) => (
                    <li key={ticket.id}>
                      <strong>Ticket:</strong> {ticket.id} - {ticket.title}
                      <Button
                        variant="link"
                        onClick={() => navigate(`/tickets/${ticket.id}/edit`)}
                      >
                        Ver Detalhes
                      </Button>
                    </li>
                  ))}
                </ul>
              )}
            </Tab>
          </Tabs>
        </Card.Footer>
      </Card>

      {/* Modal de Visualização da Descrição */}
      <Modal
        show={showDescriptionModal}
        onHide={() => {
          setShowDescriptionModal(false);
          setIsEditingDescription(false);
          setEditedDescription('');
        }}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditingDescription
              ? 'Editar Descrição do Ticket'
              : 'Descrição Completa do Ticket'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: '70vh',
            overflowY: 'auto',
            fontSize: '14px',
            lineHeight: '1.6',
            padding: '20px',
          }}
        >
          {isEditingDescription ? (
            <div style={{ height: '400px' }}>
              <ReactQuill
                theme="snow"
                value={editedDescription}
                onChange={setEditedDescription}
                style={{ height: '350px' }}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['link', 'image'],
                    ['clean'],
                  ],
                }}
              />
            </div>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: injectTokenInHtml(
                  (originalTicket && originalTicket.descricao_ticket
                    ? originalTicket.descricao_ticket
                    : 'Descrição não disponível'
                  )
                    .replace(/<p><br><\/p>/g, '<br>')
                    .replace(/<p>/g, '')
                    .replace(/<\/p>/g, '<br>')
                    .replace(/(<br>\s*){2,}/g, '<br><br>')
                    .replace(/^<br>|<br>$/g, '')
                    .replace(
                      /<img([^>]*?)style="([^"]*?)"([^>]*?)>/g,
                      '<img$1style="$2; max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"$3>'
                    )
                    .replace(
                      /<img(?![^>]*style)([^>]*?)>/g,
                      '<img$1 style="max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">'
                    )
                ),
              }}
              style={{
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          {isEditingDescription ? (
            <>
              <Button
                variant="secondary"
                onClick={handleCancelEditDescription}
                disabled={isSavingDescription}
              >
                Cancelar
              </Button>
              <Button
                variant="primary"
                onClick={handleSaveDescription}
                disabled={isSavingDescription}
              >
                {isSavingDescription ? 'Salvando...' : 'Salvar'}
              </Button>
            </>
          ) : (
            <>
              <Button variant="primary" onClick={handleEditDescription}>
                Editar Descrição
              </Button>
              <Button
                variant="secondary"
                onClick={() => setShowDescriptionModal(false)}
              >
                Fechar
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {/* Modal de Visualização das Informações do Cliente */}
      <Modal
        show={showClientInfoModal}
        onHide={() => {
          setShowClientInfoModal(false);
          setIsEditingClientInfo(false);
          setEditedClientInfo('');
        }}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditingClientInfo
              ? 'Editar Informações do Cliente'
              : 'Informações Completas do Cliente'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: '70vh',
            overflowY: 'auto',
            fontSize: '14px',
            lineHeight: '1.6',
            padding: '20px',
          }}
        >
          {isEditingClientInfo ? (
            <div style={{ minHeight: '300px' }}>
              <RichTextEditor
                value={editedClientInfo}
                onChange={setEditedClientInfo}
                onSave={handleSaveClientInfo}
                onCancel={() => {
                  setIsEditingClientInfo(false);
                  setEditedClientInfo('');
                }}
                isEditing
              />
            </div>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: injectTokenInHtml(
                  (clientInfo || 'Nenhuma informação disponível')
                    .replace(/<p><br><\/p>/g, '<br>')
                    .replace(/<p>/g, '')
                    .replace(/<\/p>/g, '<br>')
                    .replace(/(<br>\s*){2,}/g, '<br><br>')
                    .replace(/^<br>|<br>$/g, '')
                    .replace(
                      /<img([^>]*?)style="([^"]*?)"([^>]*?)>/g,
                      '<img$1style="$2; max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"$3>'
                    )
                    .replace(
                      /<img(?![^>]*style)([^>]*?)>/g,
                      '<img$1 style="max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">'
                    )
                ),
              }}
              style={{
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          {!isEditingClientInfo && (
            <>
              <Button
                variant="primary"
                onClick={() => {
                  setIsEditingClientInfo(true);
                  setEditedClientInfo(clientInfo || '');
                }}
              >
                Editar
              </Button>
              <Button
                variant="secondary"
                onClick={() => setShowClientInfoModal(false)}
              >
                Fechar
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {/* Painel lateral de informações do cliente */}
      {showInfoPanel && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setShowInfoPanel(false)}
            style={{
              position: 'fixed',
              inset: 0,
              backgroundColor: 'rgba(0,0,0,0.3)',
              zIndex: 1040,
            }}
          />

          {/* Painel */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '360px',
              height: '100vh',
              backgroundColor: '#f8f9fa',
              boxShadow: '-6px 0 24px rgba(0,0,0,0.15)',
              zIndex: 1050,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/* ── Cabeçalho do painel ── */}
            <div
              style={{
                background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
                padding: '16px 18px',
                color: '#fff',
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    className="fw-bold text-truncate"
                    style={{ fontSize: '1rem' }}
                    title={companyName}
                  >
                    {companyName}
                  </div>
                  <small style={{ opacity: 0.8 }}>Informações do cliente</small>
                </div>
                <button
                  type="button"
                  onClick={() => setShowInfoPanel(false)}
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    borderRadius: '50%',
                    color: '#fff',
                    width: '28px',
                    height: '28px',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    lineHeight: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    marginLeft: '8px',
                  }}
                  title="Fechar"
                >
                  &times;
                </button>
              </div>
            </div>

            {/* ── Área de conteúdo rolável ── */}
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {/* ── Seção: Etiquetas do Cliente ── */}
              <div
                style={{
                  backgroundColor: '#fff',
                  margin: '12px 12px 0',
                  borderRadius: '8px',
                  border: '1px solid #e9ecef',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    backgroundColor: '#e8f0fe',
                    borderBottom: '1px solid #c5d8fb',
                    padding: '8px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  <span style={{ fontSize: '0.75rem' }}>🏷️</span>
                  <span
                    style={{
                      fontSize: '0.72rem',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      color: '#1a56db',
                    }}
                  >
                    Etiquetas do Cliente
                  </span>
                </div>
                <div style={{ padding: '10px 14px' }}>
                  {companyTags.length === 0 ? (
                    <span
                      className="text-muted"
                      style={{ fontSize: '0.82rem' }}
                    >
                      Nenhuma etiqueta cadastrada.
                    </span>
                  ) : (
                    <div className="d-flex flex-wrap gap-1">
                      {companyTags.map((tag) => {
                        const tagName = String((tag && tag.name) || '');
                        const isBlocked = tagName
                          .toLowerCase()
                          .includes('bloqueado');
                        const tagStyle =
                          tag && tag.color
                            ? {
                                backgroundColor: tag.color,
                                color: '#fff',
                                border: 'none',
                              }
                            : undefined;
                        return (
                          <Badge
                            key={tag.id || tagName}
                            bg={isBlocked ? 'danger' : 'secondary'}
                            style={tagStyle}
                          >
                            {tagName}
                          </Badge>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              {/* ── Seção: Últimos 5 Tickets ── */}
              <div
                style={{
                  backgroundColor: '#fff',
                  margin: '10px 12px 0',
                  borderRadius: '8px',
                  border: '1px solid #e9ecef',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    backgroundColor: '#e9f7ef',
                    borderBottom: '1px solid #c3e6cb',
                    padding: '8px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: '6px' }}
                  >
                    <span style={{ fontSize: '0.75rem' }}>🎫</span>
                    <span
                      style={{
                        fontSize: '0.72rem',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        color: '#1a7a3a',
                      }}
                    >
                      Últimos 5 Tickets
                    </span>
                  </div>
                  <Badge bg="success" style={{ fontSize: '0.65rem' }}>
                    {recentTickets.length}
                  </Badge>
                </div>

                {recentTickets.length === 0 ? (
                  <div
                    className="text-muted text-center"
                    style={{ padding: '14px', fontSize: '0.82rem' }}
                  >
                    Nenhum ticket encontrado.
                  </div>
                ) : (
                  <div>
                    {recentTickets.slice(0, 5).map((ticket, idx) => {
                      const statusColorMap = {
                        aberto: '#0dcaf0',
                        em_atendimento: '#198754',
                        pausado: '#ffc107',
                        fechado: '#6c757d',
                        cancelado: '#dc3545',
                      };
                      const statusLabelMap = {
                        aberto: 'Aberto',
                        em_atendimento: 'Em atendimento',
                        pausado: 'Pausado',
                        fechado: 'Fechado',
                        cancelado: 'Cancelado',
                      };
                      const dotColor =
                        statusColorMap[ticket.status] || '#6c757d';
                      const statusLabel =
                        statusLabelMap[ticket.status] || ticket.status;
                      const isLast =
                        idx === recentTickets.slice(0, 5).length - 1;
                      return (
                        <div
                          key={ticket.id}
                          style={{
                            padding: '10px 14px',
                            borderBottom: isLast ? 'none' : '1px solid #f1f3f5',
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '10px',
                          }}
                        >
                          {/* Indicador de status */}
                          <div
                            style={{
                              width: '10px',
                              height: '10px',
                              borderRadius: '50%',
                              backgroundColor: dotColor,
                              flexShrink: 0,
                              marginTop: '4px',
                            }}
                          />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              style={{ marginBottom: '2px' }}
                            >
                              <span
                                className="fw-bold text-primary"
                                style={{ fontSize: '0.82rem' }}
                              >
                                #Open
                                {String(ticket.id).padStart(4, '0')}
                              </span>
                              <span
                                style={{
                                  fontSize: '0.68rem',
                                  color: dotColor,
                                  fontWeight: 600,
                                }}
                              >
                                {statusLabel}
                              </span>
                            </div>
                            <div
                              style={{
                                fontSize: '0.78rem',
                                color: '#495057',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                              title={ticket.title}
                            >
                              {ticket.title}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() =>
                              window.open(
                                `/tickets/${ticket.id}/edit`,
                                '_blank'
                              )
                            }
                            title="Abrir em nova aba"
                            style={{
                              background: 'none',
                              border: '1px solid #0d6efd',
                              borderRadius: '4px',
                              color: '#0d6efd',
                              cursor: 'pointer',
                              padding: '2px 6px',
                              flexShrink: 0,
                              fontSize: '0.7rem',
                            }}
                          >
                            <FaExternalLinkAlt size={9} />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* ── Seção: Servidores do Cliente (em breve) ── */}
              <div
                style={{
                  backgroundColor: '#fff',
                  margin: '10px 12px 12px',
                  borderRadius: '8px',
                  border: '1px solid #e9ecef',
                  overflow: 'hidden',
                  opacity: 0.6,
                }}
              >
                <div
                  style={{
                    backgroundColor: '#fdf3e3',
                    borderBottom: '1px solid #fde8c0',
                    padding: '8px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  <span style={{ fontSize: '0.75rem' }}>🖥️</span>
                  <span
                    style={{
                      fontSize: '0.72rem',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      color: '#a0522d',
                    }}
                  >
                    Servidores do Cliente
                  </span>
                  <Badge
                    bg="warning"
                    text="dark"
                    style={{ fontSize: '0.6rem', marginLeft: 'auto' }}
                  >
                    Em breve
                  </Badge>
                </div>
                <div
                  className="text-muted text-center"
                  style={{ padding: '14px', fontSize: '0.82rem' }}
                >
                  Esta seção está em desenvolvimento.
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Container>
  );
}
